import { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  en: {
    nav_dashboard: 'Dashboard', nav_bookings: 'Bookings', nav_billing: 'Billing',
    nav_customers: 'Customers', nav_services: 'Services', nav_staff: 'Staff', nav_inventory: 'Inventory', nav_reports: 'Reports', nav_logout: 'Logout',
    search: 'Search', save: 'Save', saving: 'Saving...', cancel: 'Cancel', delete: 'Delete',
    remove: 'Remove', edit: 'Edit', add: 'Add', confirm: 'Confirm', close: 'Close',
    name: 'Name', phone: 'Phone', email: 'Email', notes: 'Notes',
    login_welcome: 'Welcome Back', login_subtitle: 'Sign in to manage your salon',
    login_create: 'Create Account', login_create_sub: 'Set up your salon in minutes',
    login_your_name: 'Your Name', login_salon_name: 'Salon Name',
    login_sign_in: 'Sign In', login_sign_up: 'Create Account',
    login_no_account: "Don't have an account? Sign Up",
    login_have_account: 'Already have an account? Sign In',
    auth_session_expired: 'Your session has expired. Please sign in again.',
    errb_title: 'Something went wrong',
    errb_subtitle: 'An error occurred.',
    errb_retry: 'Try Again',
    errb_logged: 'Error has been logged.',
    offline_banner: 'You are offline — changes will not be saved',
    offline_toast_restored: 'Internet is back!',
    login_load_demo: 'Load Demo Data', login_demo_desc: 'Sets up sample services, staff & customers',
    login_tagline: 'Your Complete Salon\nManagement Solution',
    login_tagline_desc: 'Manage bookings, billing, staff, and customers — all in one beautiful app.',
    login_enter_name: 'Enter your name', login_enter_email: 'you@example.com',
    login_enter_pass: 'Enter password', login_enter_salon: 'e.g. Glamour Studio',
    email: 'Email', password: 'Password', your_name: 'Your Name', salon_name: 'Salon Name',
    confirm_password: 'Confirm Password', sign_in: 'Sign In', create_account: 'Create Account',
    signing_in: 'Signing in...', creating_account: 'Creating account...',
    invalid_credentials: 'Invalid email or password', already_have_account: 'Already have an account?',
    dont_have_account: "Don't have an account?", sign_up: 'Sign Up', sign_in_link: 'Sign In',
    welcome_back: 'Welcome Back', sign_in_subtitle: 'Sign in to manage your salon',
    create_account_subtitle: 'Set up your salon in minutes', forgot_password: 'Forgot Password?',
    password_strength: 'Password Strength', strength_weak: 'Weak', strength_fair: 'Fair', strength_good: 'Good', strength_strong: 'Strong',
    val_email_required: 'Email is required', val_email_invalid: 'Enter a valid email',
    val_password_required: 'Password is required', val_password_min: 'Password must be at least 8 characters', val_password_min_login: 'Password must be at least 6 characters',
    val_name_required: 'Name is required', val_name_min: 'Name must be at least 2 characters',
    val_salon_required: 'Salon name is required', val_passwords_match: 'Passwords do not match',
    forgot_title: 'Forgot your password?',
    forgot_body: 'Please contact your SalonSync administrator to reset your password.',
    forgot_hint: 'Admin can reset passwords from Settings → User Management',
    back_to_login: '← Back to Login',
    dash_morning: 'Good Morning', dash_afternoon: 'Good Afternoon', dash_evening: 'Good Evening',
    dash_today_rev: "Today's Revenue", dash_today_book: "Today's Bookings",
    dash_new_cust: 'New Customers', dash_top_svc: 'Top Service',
    dash_pending: 'pending', dash_this_month: 'This month',
    dash_new_booking: 'New Booking', dash_new_bill: 'New Bill', dash_add_cust: 'Add Customer',
    dash_rev_7: 'Revenue (Last 7 Days)', dash_svc_cat: 'Service Categories',
    dash_upcoming: 'Upcoming Appointments', dash_view_all: 'View All',
    dash_no_billing: 'No billing data yet. Create your first bill!',
    dash_no_upcoming: 'No upcoming appointments', dash_revenue: 'Revenue',
    access_restricted: 'Access Restricted',
    access_restricted_body: 'Your role ({role}) does not have permission to view this page.',
    access_stylist_hint: 'You can access: Dashboard and Bookings',
    access_receptionist_hint: 'You can access: Dashboard, Bookings, Billing and Customers',
    access_manager_hint: 'You can access everything except Settings',
    go_to_dashboard: '← Go to Dashboard',
    my_schedule_today: 'My Schedule Today',
    no_bookings_today_stylist: 'No bookings scheduled for you today',
    bill_search: 'Search services...', bill_items: 'Bill Items', bill_customer: 'Customer',
    bill_pricing: 'Pricing Summary', bill_pay_method: 'Payment Method',
    bill_mark_paid: 'Mark as Paid', bill_processing: 'Processing...',
    bill_subtotal: 'Subtotal', bill_discount: 'Discount',
    bill_cgst: 'CGST (9%)', bill_sgst: 'SGST (9%)', bill_total: 'Total',
    bill_cash: 'Cash', bill_card: 'Card', bill_upi: 'UPI', bill_split: 'Split',
    bill_search_cust: 'Search customer by name or phone...',
    bill_walkin: 'or continue as Walk-in', bill_remove_cust: 'Remove Customer',
    no_customer_found: 'No customer found for "{query}"',
    create_new_customer: 'Create New Customer',
    new_customer_title: 'New Customer',
    new_customer_save: 'Save & Continue',
    new_customer_created: '✓ New customer created',
    bill_success: 'Payment Successful!', bill_download: 'Download Receipt (PDF)',
    bill_whatsapp: 'Send via WhatsApp', bill_new: 'New Bill',
    bill_loyalty: 'loyalty points', bill_estimated: 'Estimated',
    bill_add_items: 'Add items to bill first', bill_complete: 'Payment completed successfully!',
    bill_added: 'Added',
    bill_products_used: 'Products Used (Optional)',
    bill_product_search: 'Search products...',
    bill_products_added: 'products added',
    bill_available: 'Available',
    bill_internal_cost: 'Internal Product Cost',
    bill_ab_low_stock: 'ab low stock mein hai!',
    bill_out_of_stock: 'OUT OF STOCK ho gaya!',
    bill_products_select: 'Select Products',
    bill_product_search_modal: 'Search by name...',
    bill_available_lower: 'available',
    bill_out_of_stock_label: 'Out of Stock',
    bill_products_selected: 'products selected',
    bill_confirm_add: 'Confirm Add',
    bill_add_more: '+ Add More',
    bill_product_cost_internal: 'Product Cost (Internal)',
    served_by: 'Served By',
    select_staff: 'Select staff member...',
    not_specified: 'Not specified',
    served_by_optional: 'Optional — can skip for walk-ins',
    bill_recent_bills: 'Recent Bills',
    staff_performance_bills: 'from bills',
    staff_performance_bookings: 'bookings',
    low_stock_toast: '⚠️ {product} is running low on stock! Please restock.',
    out_of_stock_toast: '🚨 {product} is now OUT OF STOCK!',
    stock_deducted: 'Stock updated for {product}',
    cust_search: 'Search by name or phone...', cust_add: 'Add Customer',
    cust_edit: 'Edit Customer', cust_profile: 'Customer Profile',
    cust_visits: 'visits', cust_total: 'Total Spent', cust_points: 'Points',
    cust_none: 'No customers found', cust_history: 'Visit History',
    cust_bookings: 'Bookings', view_bookings: 'View all bookings',
    cust_no_history: 'No billing history yet',
    cust_req: 'Name and phone are required', cust_added: 'Customer added',
    cust_updated: 'Customer updated', cust_birthday: 'Birthday', cust_gender: 'Gender',
    cust_prefs: 'Preferences, allergies, etc.',
    customer_deactivate: 'Deactivate',
    customer_deactivate_confirm_title: 'Deactivate this customer?',
    customer_deactivate_confirm_body: 'This customer will be removed from the active list. Their data will be safe.',
    customer_deactivated_toast: 'Customer deactivated',
    customer_reactivate: 'Reactivate',
    customer_reactivated_toast: 'Customer reactivated',
    show_inactive_customers: 'Show inactive customers',
    customer_inactive_badge: 'Inactive',
    customer_deactivate_confirm_btn: 'Yes, Deactivate',
    customer_since: 'Customer since',
    total_visits: 'Total Visits',
    total_spent: 'Total Spent',
    avg_bill: 'Avg Bill',
    last_visit: 'Last Visit',
    days_ago: '{count} days ago',
    today: 'Today',
    yesterday: 'Yesterday',
    no_visits_yet: 'No visits yet',
    customer_details: 'Customer Details',
    birthday: 'Birthday',
    gender: 'Gender',
    notes_label: 'Notes',
    not_provided: 'Not provided',
    no_notes: 'No notes',
    visit_history_count: 'Visit History ({count})',
    bookings_count: 'Bookings ({count})',
    load_more_visits: 'Load More Visits →',
    points_to_tier: '{count} points to {tier}',
    top_customer_badge: '🏆 Top Customer!',
    loyalty_points: 'Loyalty Points',
    points_value: 'Points Value',
    top_services: 'Top Services',
    visit_history: 'Visit History',
    this_month: 'This Month',
    this_month_visits: 'This month visits',
    this_month_spent: 'This month spent',
    next_tier_progress: 'Progress to next tier',
    top_customer: 'Top Customer!',
    new_bill: 'New Bill',
    new_booking: 'New Booking',
    profile_load_error: 'Failed to load profile. Please try again.',
    profile_retry: 'Retry',
    more_visits_message: 'Go to Reports to see more visit history',
    payment_cash: 'Cash',
    payment_card: 'Card',
    payment_upi: 'UPI',
    loyalty_earned: 'Loyalty earned',
    points_to_next_tier: 'points to next tier',
    how_tiers_work: 'How tiers work ▼',
    how_tiers_work_close: 'How tiers work ▲',
    tier_bronze: 'Bronze',
    tier_silver: 'Silver',
    tier_gold: 'Gold',
    tier_diamond: 'Diamond',
    tier_bronze_range: '0 – 2,000 pts',
    tier_silver_range: '2,001 – 5,000 pts',
    tier_gold_range: '5,001 – 10,000 pts',
    tier_diamond_range: '10,001+ pts',
    tier_earn_rate: 'Each ₹1 spent = 1 loyalty point',
    tier_redeem_info: 'Points can be redeemed for discounts',
    pts_to_next_tier: '{count} pts needed for {tier}',
    top_tier_achieved: '🏆 Top tier achieved!',
    loyalty_tiers: 'Loyalty Tiers',
    loyalty_tiers_subtitle: 'Define point thresholds for each customer tier',
    tier_min_points: 'Min Points',
    tier_max_points: 'Max Points',
    tier_min_auto: 'auto',
    tier_preview: 'Tier Preview',
    tier_badges_preview: 'Tier Badges Preview',
    tier_threshold_error: '{higher} threshold must be greater than {lower}',
    how_tiers_work_link: 'ℹ️ How tiers work →',
    tier_table_tier: 'Tier',
    svc_search: 'Search services...', svc_add: 'Add Service', svc_edit: 'Edit Service',
    svc_name: 'Service Name', svc_category: 'Category', svc_duration: 'Duration (mins)',
    svc_price: 'Price (₹)', svc_gst: 'GST Rate (%)', svc_active: 'Active', svc_inactive: 'Inactive',
    svc_del_title: 'Delete Service?', svc_del_desc: 'This action cannot be undone.',
    svc_none: 'No services found', svc_added: 'Service added',
    svc_updated: 'Service updated', svc_deleted: 'Service deleted',
    svc_req: 'Name and price are required',
    staff_search: 'Search staff by name or phone...', staff_add: 'Add Staff', staff_edit: 'Edit Staff',
    staff_role: 'Role', staff_comm: 'Commission (%)',
    staff_in: 'Clock In', staff_out: 'Clock Out', staff_working: 'Currently Working',
    staff_del_title: 'Remove Staff Member?', staff_del_desc: 'This action cannot be undone.',
    staff_none: 'No staff found', staff_clocked_in: 'Clocked in!',
    staff_clocked_out: 'Clocked out!', staff_added: 'Staff added',
    staff_updated: 'Staff updated', staff_removed: 'Staff removed',
    staff_req: 'Name and phone are required',
    staff_on_duty: 'On duty',
    staff_off_duty: 'Off duty',
    staff_total: 'Total Staff',
    staff_on_duty_now: 'On Duty Now',
    staff_off_duty_now: 'Off Duty',
    staff_sub_team_members: 'team members',
    staff_sub_currently_working: 'currently working',
    staff_sub_not_clocked: 'not clocked in',
    staff_stat_label_today: 'Today',
    staff_stat_label_served: 'Served',
    monthly_hours_summary: 'Monthly Hours Summary',
    today_stats: "Today's Stats",
    hours_worked_today: 'worked today',
    customers_today: 'customers served',
    revenue_today: 'revenue today',
    live_timer: 'Live',
    now: 'Now',
    staff: 'Staff',
    attendance: 'Attendance',
    customers: 'Customers',
    revenue: 'Revenue',
    commission: 'Commission',
    clock_in: 'Clock In',
    clock_out: 'Clock Out',
    total: 'Total',
    joined: 'Joined',
    visits: 'Visits',
    times: 'Times',
    customers_served: 'Customers served',
    revenue_generated: 'Revenue generated',
    in_progress: 'In Progress',
    short_day: 'Short Day',
    mon: 'Mon', tue: 'Tue', wed: 'Wed', thu: 'Thu', fri: 'Fri', sat: 'Sat', sun: 'Sun',
    this_week: 'This Week',
    revenue_last_7_days: 'Revenue (last 7 days)',
    attendance_overview: 'Attendance Overview',
    attendance_month_year_title: 'Select month & year',
    attendance_year_label: 'Year',
    attendance_month_label: 'Month',
    all_staff: 'All Staff',
    full_day: 'Full Day',
    half_day: 'Half Day',
    absent: 'Absent',
    holiday: 'Holiday',
    no_data: 'No Data',
    hours_today: 'Today',
    hours_this_week: 'This Week',
    hours_this_month: 'This Month',
    avg_per_day: 'Avg/day',
    days_worked: 'Days worked',
    full_days: 'Full days',
    half_days: 'Half days',
    mark_holiday: 'Mark as Holiday',
    mark_absent: 'Mark as Absent',
    staff_overview: 'Overview',
    staff_attendance: 'Attendance',
    staff_performance: 'Performance',
    joining_date: 'Joining Date',
    all_time_hours: 'All Time Hours',
    days_present: 'Days Present',
    days_absent: 'Days Absent',
    book_new: 'New Booking', book_today: 'Today',
    book_none: 'No bookings for', book_first: 'Create First Booking',
    book_customer: 'Customer', book_services: 'Services',
    book_stylist: 'Stylist', book_time: 'Time Slot', book_notes: 'Notes',
    book_confirm: 'Confirm', book_start: 'Start', book_complete: 'Complete',
    book_cancel: 'Cancel', book_del_title: 'Delete Booking?',
    book_del_desc: 'This action cannot be undone.',
    book_any: 'Any available', book_special: 'Any special requests...',
    book_created: 'Booking created', book_deleted: 'Booking deleted',
    book_req: 'Customer and at least one service required',
    book_search_cust: 'Search customer...', book_create: 'Create Booking',
    book_new_for: 'New Booking for',
    booking_scheduled: 'Scheduled',
    booking_completed: 'Completed',
    booking_cancelled: 'Cancelled',
    booking_no_show: 'No Show',
    booking_complete_btn: 'Complete',
    booking_no_show_btn: 'No Show',
    booking_cancel_btn: 'Cancel Booking',
    booking_edit_btn: 'Edit',
    booking_create_bill: 'Create Bill →',
    booking_past_date_warning: 'You are booking for a past date. This is allowed for recording past appointments.',
    booking_past_time_warning: 'This time has already passed. Continue to record a past appointment.',
    booking_cancel_confirm_title: 'Cancel this booking?',
    booking_cancel_confirm_body: 'This booking will be marked as cancelled. This cannot be undone.',
    booking_cancel_confirm_btn: 'Yes, Cancel Booking',
    booking_keep_btn: 'Keep Booking',
    booking_noshow_confirm_title: 'Mark as No Show?',
    booking_noshow_confirm_body: '{name} did not arrive for their appointment?',
    booking_noshow_confirm_btn: 'Yes, No Show',
    booking_update_btn: 'Update Booking',
    edit_booking_title: 'Edit Booking',
    no_bookings_today: 'No bookings for {date}',
    no_filtered_bookings: 'No {status} bookings for {date}',
    booking_filter_all: 'All',
    booking_filter_scheduled: 'Scheduled',
    booking_filter_completed: 'Completed',
    booking_filter_cancelled: 'Cancelled',
    booking_filter_no_show: 'No Show',
    booking_new_customer_phone: 'Phone (new customer)',
    booking_new_customer_phone_placeholder: '10-digit phone number',
    booking_new_customer_phone_required: 'Phone required to create new customer',
    lang_title: 'LANGUAGE',
    rpt_title: 'Reports & Analytics',
    rpt_subtitle: 'Track your salon growth in one place',
    rpt_total_revenue: 'Total Revenue',
    rpt_total_bookings: 'Total Bookings',
    rpt_new_customers: 'New Customers',
    rpt_avg_bill_value: 'Avg Bill Value',
    rpt_revenue_trend: 'Revenue Trend',
    rpt_top_services: 'Top Services',
    rpt_payment_methods: 'Payment Methods',
    rpt_staff_performance: 'Staff Performance',
    rpt_customer_insights: 'Customer Insights',
    rpt_returning_vs_new: 'Returning vs New Customers',
    rpt_peak_hours: 'Peak Hours',
    rpt_export: 'Export',
    rpt_no_data: 'No data for this period',
    rpt_today: 'Today',
    rpt_this_week: 'This Week',
    rpt_this_month: 'This Month',
    rpt_custom: 'Custom',
    rpt_appointments: 'Appointments',
    rpt_revenue_generated: 'Revenue Generated',
    rpt_commission_earned: 'Commission Earned',
    rpt_top_service: 'Top Service',
    rpt_cash: 'Cash',
    rpt_card: 'Card',
    rpt_upi: 'UPI',
    rpt_select_start_date: 'Select Start Date',
    rpt_select_end_date: 'Select End Date',
    rpt_apply: 'Apply',
    rpt_export_csv: 'Export as CSV',
    rpt_export_pdf: 'Export as PDF',
    rpt_export_excel: 'Export as Excel',
    rpt_share_report: 'Share Report',
    rpt_staff: 'Staff',
    rpt_revenue: 'Revenue',
    rpt_bookings: 'Bookings',
    rpt_reports_load_error: 'Failed to load reports',
    rpt_export_no_data: 'No data to export',
    rpt_export_csv_done: 'CSV exported',
    rpt_times_booked: 'times booked',
    rpt_product_usage: 'Product usage (cost)',
    rpt_product_name: 'Product',
    rpt_quantity_used: 'Qty used',
    rpt_total_cost: 'Total cost',
    rpt_returning: 'Returning',
    rpt_new: 'New',
    rpt_summary_copied: 'Summary copied to clipboard!',
    rpt_payment: 'Payment',
    rpt_customers: 'Customers',
    rpt_date: 'Date',
    rpt_period: 'Period',
    rpt_service: 'Service',
    rpt_name: 'Name',
    rpt_role: 'Role',
    rpt_generated_by: 'Generated by SalonSync',
    rpt_generated_on: 'Generated on',
    settings: 'Settings',
    settings_salon_profile: 'Salon Profile',
    settings_notifications: 'Notifications',
    settings_billing: 'Billing Settings',
    settings_user_mgmt: 'User Management',
    settings_data_backup: 'Data & Backup',
    settings_salon_name: 'Salon Name',
    settings_phone: 'Phone',
    settings_email: 'Email',
    settings_address: 'Address',
    settings_gst: 'GST Number',
    settings_website: 'Website',
    settings_save: 'Save Changes',
    settings_saved: 'Settings saved!',
    settings_inv_prefix: 'Invoice Prefix',
    settings_next_inv: 'Next Invoice Number',
    settings_loyalty_per_rupee: 'Loyalty Points per ₹ spent',
    settings_redemption_per_point: 'Redemption ₹ per point',
    notif_booking_title: 'Auto-send Booking Confirmation',
    notif_booking_sub: 'Send WhatsApp when a booking is created',
    notif_bill_title: 'Auto-send Bill via WhatsApp',
    notif_bill_sub: 'Send receipt after payment via WhatsApp',
    notif_birthday_title: 'Birthday Wishes',
    notif_birthday_sub: 'Auto-send birthday message to customers',
    notif_reminder_title: 'Appointment Reminder',
    notif_reminder_sub: 'Send reminder before appointment',
    whatsapp_note: 'WhatsApp Business API required for integration. Currently works manually via WhatsApp Web.',
    email_config: 'Email Configuration',
    resend_api_key: 'Resend API Key',
    resend_api_key_help: 'Get your free API key at resend.com',
    resend_open: 'Open Resend ↗',
    resend_api_key_placeholder: 're_xxxxxxxxxxxxxxxx',
    resend_api_key_invalid: 'Invalid Resend API key format. Keys start with re_',
    resend_used_for: 'Used for: password reset emails, booking confirmations, receipts',
    test_email: 'Send Test Email',
    test_email_sending: 'Sending...',
    test_email_success: 'Test email sent! Check your inbox.',
    test_email_failed: 'Email send failed. Check your API key.',
    resend_key_saved: 'Email settings saved',
    using_system_email: 'Using system default email (add your key for custom sender)',
    settings_field_required: 'is required',
    settings_user_req: 'Name and email required',
    settings_user_updated: 'User updated',
    settings_user_added: 'User added',
    settings_backup_complete: 'Backup complete! 4 files downloaded.',
    settings_backup_failed: 'Backup failed',
    settings_try_again: 'Please try again',
    settings_restore_success: 'Data restored!',
    settings_restore_unknown: 'Unknown file type. Use customers, bookings, services, or staff CSV.',
    settings_users_demo: 'This feature is in demo mode. Real login system coming soon.',
    settings_table_user: 'User',
    settings_table_role: 'Role',
    settings_table_status: 'Status',
    settings_table_actions: 'Actions',
    settings_add_user: 'Add User',
    settings_backup_full: 'Full Backup to CSV',
    settings_restore_btn: 'Restore from Backup',
    settings_last_backup: 'Last backup',
    settings_never: 'Never',
    settings_edit_user: 'Edit User',
    settings_password_keep: '(leave blank to keep)',
    settings_update: 'Update',
    settings_add_karo: 'Add',
    settings_restore_title: 'Restore from Backup',
    settings_restore_confirm: 'Restore will replace all current data. Are you sure?',
    settings_restore_yes: 'Yes, Restore',
    settings_password: 'Password',
    settings_status_active: 'Active',
    settings_status_inactive: 'Inactive',
    settings_you_badge: 'You',
    settings_password_optional_hint: 'Leave blank to keep current password',
    settings_confirm_password: 'Confirm Password',
    settings_deactivate_confirm: 'Deactivate this user?',
    settings_deactivate: 'Deactivate',
    settings_users_load_error: 'Failed to load users',
    inv_total_products: 'Total Products',
    inv_low_stock: 'Low Stock',
    inv_inventory_value: 'Inventory Value',
    inv_product_add: 'Add Product',
    inv_product_search: 'Search products...',
    inv_filter_all: 'All',
    inv_filter_low_stock: 'Low Stock',
    inv_filter_out_of_stock: 'Out of Stock',
    inv_min_threshold: 'Min Threshold',
    inv_cost_price: 'Cost Price',
    inv_brand: 'Brand',
    inv_stock_history: 'Stock History',
    inv_stock_add: 'Add Stock',
    inv_stock_reduce: 'Reduce Stock',
    inv_update_karo: 'Update',
    inv_reason_new_stock: 'New Stock',
    inv_reason_return: 'Return',
    inv_reason_correction: 'Correction',
    inv_reason_used: 'Used in Service',
    inv_reason_damaged: 'Damaged',
    inv_reason_expired: 'Expired',
    inv_products_low_stock: 'products are low on stock',
    inv_whatsapp_alert: 'Send WhatsApp Alert',
    inv_low_stock_alert: 'Low Stock Alert',
    inv_restock_karo: 'Restock',
    inv_stock_updated: 'Stock updated!',
    inv_dismiss: 'Dismiss',
    inv_clear_history: 'Clear History',
    inv_low_stock_in: 'is low on stock',
    inv_save_karo: 'Save',
    inv_min_alert_helper: 'You will get an alert when stock goes below this',
    inv_current_stock: 'Current Stock',
    inv_product_name: 'Product Name',
    inv_category: 'Category',
    inv_unit: 'Unit',
    inv_type: 'Type',
    inv_quantity: 'Qty',
    inv_reason: 'Reason',
    inv_time: 'Time',
    inv_clear_confirm: 'Clear history?',
    inv_del_title: 'Delete Product?',
    inv_del_desc: 'This action cannot be undone.',
    inv_none: 'No products found',
    inv_add_stock: 'Add Stock',
    inv_stock_btn: 'Stock',
    inv_product: 'Product',
    inv_load_error: 'Failed to load data. Please try again.',
    inv_retry: 'Retry',
    inv_save_error: 'Failed to save. Please try again.',
    inv_delete_error: 'Failed to delete.',
    inv_stock_update_error: 'Failed to update stock.',
    inv_history_load_error: 'Failed to load history.',
    inv_history_clear_error: 'Failed to clear history.',
    inv_whatsapp_restock_intro: 'Products below need restocking:',
    inv_whatsapp_footer: 'Sent from SalonSync',
    use_tracking: 'Use-based tracking',
    use_per_unit: 'Uses per {unit}',
    use_name: 'Use name',
    use_stroke: 'stroke',
    use_pump: 'pump',
    use_spray: 'spray',
    use_scoop: 'scoop',
    use_available: 'strokes available',
    use_alert_below: 'Alert below (uses)',
    use_bottles_added: 'bottles added = {x} strokes added',
    use_one_call: 'What do you call one use?',
    use_stock_label: 'Use-based stock',
    use_per_use: 'per use',
    use_modal_helper: 'How many uses per container?',
    use_alert_helper: 'Alert when uses left below',
    use_status: '{x} {useUnit}s available across {y} {unit}s',
    use_kitni_units: 'How many {units} added?',
    use_kitne_use: 'How many {useUnit} used?',
    use_added_msg: '{units} added = {x} {useUnit} added',
    val_name_min: 'At least 2 characters required',
    val_name_max: 'Maximum 100 characters',
    val_stock_min: 'Must be 0 or more',
    val_stock_number: 'Must be a number',
    val_uses_required: 'Required when use-based tracking is on',
    val_uses_min: 'At least 1 required',
    val_phone_10: 'Exactly 10 digits required',
    val_phone_numbers: 'Numbers only',
    val_email_invalid: 'Enter a valid email or leave empty',
    val_customer_or_walkin: 'Select a customer or continue as walk-in',
    val_services_one: 'Select at least one service',
    val_date_past: 'Date/time is in the past',
    val_payment_method: 'Select payment method',
    del_confirm_title: 'Delete karna chahte hain?',
    del_confirm_desc: 'Ye action undo nahi ho sakta.',
    del_confirm_btn: 'Yes, Delete',
    del_cancel: 'Cancel',
    notifications: 'Notifications',
    mark_all_read: 'Mark all read',
    no_notifications: 'No notifications',
    low_stock_notif: 'Low Stock',
    new_booking_notif: 'New Booking',
    payment_notif: 'Payment',
    system_notif: 'System',
    my_profile: 'My Profile',
    change_password: 'Change Password',
    current_password: 'Current Password',
    new_password: 'New Password',
    confirm_new_password: 'Confirm New Password',
    password_changed: 'Password changed!',
    logout_confirm: 'Log out?',
    logout_confirm_title: 'Logout karein?',
    just_now: 'Just now',
    min_ago: 'min ago',
    hour_ago: '1 hour ago',
    hours_ago: 'hours ago',
    view_inventory: 'View Inventory',
    view_bookings: 'View Bookings',
    older_notifications: 'Older notifications',
    notif_select: 'Select',
    notif_selected: 'selected',
    notif_delete_selected: 'Delete Selected',
    notif_delete_all: 'Delete All',
    notif_delete_all_confirm_title: 'Delete all notifications?',
    notif_delete_all_confirm_body: 'This action cannot be undone.',
    notif_delete_all_confirm_btn: 'Yes, Delete All',
    notif_deleted: 'Notification deleted',
    notif_deleted_count: '{count} notifications deleted',
    notif_delete_single_confirm: 'Delete this notification?',
    payment_received: 'Payment Received',
    new_customer_added: 'New Customer Added',
    new_staff_added: 'New Staff Added',
    staff_clock_in_notif: 'Staff started work',
    staff_clock_out_notif: 'Staff clocked out',
    new_product_added: 'New Product Added',
    stock_updated: 'Stock Updated',
    new_service_added: 'New Service Added',
    settings_updated_notif: 'Settings Updated',
    select_cancel: 'Cancel',
    hours_worked: 'hours worked',
    notif_low_stock_title: 'Low Stock Alert',
    notif_low_stock_message: '{product} is running low on stock',
    notif_payment_title: 'Payment Received',
    notif_payment_message: '{customer} - ₹{amount} received via {method}',
    notif_walkin_payment_message: 'Walk-in - ₹{amount} received via {method}',
    notif_new_customer_title: 'New Customer Added',
    notif_new_customer_message: "{name}'s account has been created",
    notif_new_staff_title: 'New Staff Added',
    notif_new_staff_message: '{name} ({role}) has been added',
    notif_clock_in_title: 'Staff Clocked In',
    notif_clock_in_message: '{name} started work today',
    notif_clock_out_title: 'Staff Clocked Out',
    notif_clock_out_message: '{name} worked {hours} hours today',
    notif_new_product_title: 'New Product Added',
    notif_new_product_message: '{name} added to inventory',
    notif_stock_updated_title: 'Stock Updated',
    notif_stock_updated_message: '{quantity} {unit} added to {name}',
    notif_new_service_title: 'New Service Added',
    notif_new_service_message: '{name} - ₹{price} added',
    notif_new_booking_title: 'New Booking',
    notif_new_booking_message: "{customer}'s booking at {time}",
    notif_settings_title: 'Settings Updated',
    notif_settings_message: 'Salon profile has been updated',
    notif_welcome_title: 'Welcome to SalonSync!',
    notif_welcome_message: 'Setup complete. Add your services, staff and start billing!',
    loading: 'Loading...',
    delete_failed: 'Delete failed',
    password_mismatch: 'Passwords do not match',
    password_required: 'Current password is required',
    password_update_failed: 'Password update failed',
    dash_load_error: 'Failed to load dashboard data',
    book_load_error: 'Failed to load bookings',
    book_create_error: 'Failed to create booking',
    book_status_error: 'Failed to update status',
    update_failed: 'Failed to update',
    book_delete_error: 'Failed to delete',
    book_whatsapp_confirm: 'Would you like to send confirmation via WhatsApp?',
    book_status_updated: 'Booking {status}',
    book_whatsapp_coming_soon: 'WhatsApp reminder: Coming soon!',
    settings_load_error: 'Failed to load settings',
    settings_save_error: 'Failed to save',
    cust_load_error: 'Failed to load customers',
    cust_save_error: 'Failed to save customer',
    cust_edit_load_error: 'Failed to load customer for edit',
    cust_deactivate_error: 'Failed to deactivate',
    cust_reactivate_error: 'Failed to reactivate',
    bill_payment_failed: 'Payment failed. Please try again.',
    bill_receipt_downloaded: 'Receipt PDF downloaded',
    bill_whatsapp_coming_soon: 'WhatsApp integration coming soon!',
    svc_load_error: 'Failed to load services',
    svc_save_error: 'Failed to save service',
    svc_delete_error: 'Failed to delete service',
    staff_load_error: 'Failed to load staff',
    staff_save_error: 'Failed to save staff',
    staff_clock_in_error: 'Failed to clock in',
    staff_clock_out_error: 'Failed to clock out',
    staff_delete_error: 'Failed to delete staff',
    app_access: 'App Access',
    give_app_access: 'Give SalonSync app access',
    app_access_enabled: 'App access enabled',
    app_access_disabled: 'No app access',
    app_access_card_active: 'Active',
    app_access_card_off: 'Not enabled',
    app_access_no_access: 'No access',
    app_access_active_line: 'Active — {email}',
    app_access_optional_section: 'App Access (Optional)',
    app_access_cannot_login: 'Staff member won\'t be able to login to SalonSync.',
    app_access_login_blurb: 'They will login with these credentials. Role: {role} — {access}',
    enable_login: 'Enable Login',
    disable_login: 'Remove App Access',
    change_password: 'Change Password',
    login_email: 'Login Email',
    login_password: 'Login Password',
    login_password_placeholder: 'Min 8 characters',
    staff_app_access_title: 'Staff App Access',
    staff_app_access_subtitle: 'Manage which staff can login to SalonSync and what they can access',
    add_staff_member: 'Add Staff Member',
    staff_table_member: 'Staff Member',
    staff_has_app_access_email: 'Has app access ({email})',
    remove_app_access_confirm: 'They will no longer be able to sign in. You can enable access again later.',
    role_access_owner: 'Full access',
    role_access_manager: 'All except Settings',
    role_access_receptionist: 'Bookings, Billing, Customers',
    role_access_stylist: 'Bookings only',
    auth_failed: 'Authentication failed',
    demo_loaded: 'Demo data loaded! Login with owner@salonsync.com / admin123',
    demo_load_error: 'Failed to seed demo data',
    login_welcome_toast: 'Welcome, {name}!',
    login_welcome_back_toast: 'Welcome back, {name}!',
  },
  hi: {
    nav_dashboard: 'डैशबोर्ड', nav_bookings: 'बुकिंग', nav_billing: 'बिलिंग',
    nav_customers: 'ग्राहक', nav_services: 'सेवाएं', nav_staff: 'कर्मचारी', nav_inventory: 'इन्वेंटरी', nav_reports: 'रिपोर्ट्स', nav_logout: 'लॉग आउट',
    search: 'खोजें', save: 'सहेजें', saving: 'सहेज रहे हैं...', cancel: 'रद्द करें', delete: 'हटाएं',
    remove: 'हटाएं', edit: 'संपादित करें', add: 'जोड़ें', confirm: 'पुष्टि करें', close: 'बंद करें',
    name: 'नाम', phone: 'फोन', email: 'ईमेल', notes: 'नोट्स',
    login_welcome: 'वापस स्वागत है', login_subtitle: 'अपने सैलून का प्रबंधन करें',
    login_create: 'खाता बनाएं', login_create_sub: 'मिनटों में अपना सैलून सेटअप करें',
    login_your_name: 'आपका नाम', login_salon_name: 'सैलून का नाम',
    login_sign_in: 'साइन इन', login_sign_up: 'खाता बनाएं',
    login_no_account: 'खाता नहीं है? साइन अप करें',
    login_have_account: 'पहले से खाता है? साइन इन करें',
    auth_session_expired: 'Session expire ho gayi. Dobara login karein.',
    errb_title: 'कुछ गड़बड़ हो गई',
    errb_subtitle: 'Something went wrong',
    errb_retry: 'दोबारा ट्राई करें',
    errb_logged: 'Error has been logged.',
    offline_banner: 'इंटरनेट नहीं है — बदलाव सेव नहीं होंगे',
    offline_toast_restored: 'इंटरनेट वापस आ गया!',
    login_load_demo: 'डेमो डेटा लोड करें', login_demo_desc: 'सैंपल सेवाएं, कर्मचारी और ग्राहक सेटअप करें',
    login_tagline: 'आपका संपूर्ण सैलून\nप्रबंधन समाधान',
    login_tagline_desc: 'बुकिंग, बिलिंग, कर्मचारी और ग्राहक — सब एक ऐप में।',
    login_enter_name: 'अपना नाम दर्ज करें', login_enter_email: 'you@example.com',
    login_enter_pass: 'पासवर्ड दर्ज करें', login_enter_salon: 'जैसे: ग्लैमर स्टूडियो',
    email: 'ईमेल', password: 'पासवर्ड', your_name: 'आपका नाम', salon_name: 'सैलून का नाम',
    confirm_password: 'पासवर्ड पुष्टि करें', sign_in: 'साइन इन', create_account: 'खाता बनाएं',
    signing_in: 'साइन इन हो रहे हैं...', creating_account: 'खाता बन रहा है...',
    invalid_credentials: 'गलत ईमेल या पासवर्ड', already_have_account: 'पहले से खाता है?',
    dont_have_account: 'खाता नहीं है?', sign_up: 'साइन अप', sign_in_link: 'साइन इन',
    welcome_back: 'वापसी पर स्वागत', sign_in_subtitle: 'अपने सैलून को मैनेज करें',
    create_account_subtitle: 'मिनटों में सेटअप करें', forgot_password: 'पासवर्ड भूल गए?',
    password_strength: 'पासवर्ड मजबूती', strength_weak: 'कमज़ोर', strength_fair: 'ठीक', strength_good: 'अच्छा', strength_strong: 'मज़बूत',
    val_email_required: 'ईमेल जरूरी है', val_email_invalid: 'सही ईमेल डालें',
    val_password_required: 'पासवर्ड जरूरी है', val_password_min: 'पासवर्ड कम से कम 8 अक्षर का हो', val_password_min_login: 'पासवर्ड कम से कम 6 अक्षर का हो',
    val_name_required: 'नाम जरूरी है', val_name_min: 'नाम कम से कम 2 अक्षर का हो',
    val_salon_required: 'सैलून का नाम जरूरी है', val_passwords_match: 'पासवर्ड मेल नहीं खाते',
    forgot_title: 'पासवर्ड भूल गए?',
    forgot_body: 'कृपया अपने SalonSync एडमिन से पासवर्ड रीसेट करने को कहें।',
    forgot_hint: 'एडमिन Settings → User Management से पासवर्ड बदल सकते हैं',
    back_to_login: '← लॉगिन पर वापस',
    dash_morning: 'सुप्रभात', dash_afternoon: 'शुभ दोपहर', dash_evening: 'शुभ संध्या',
    dash_today_rev: 'आज की आय', dash_today_book: 'आज की बुकिंग',
    dash_new_cust: 'नए ग्राहक', dash_top_svc: 'शीर्ष सेवा',
    dash_pending: 'लंबित', dash_this_month: 'इस महीने',
    dash_new_booking: 'नई बुकिंग', dash_new_bill: 'नया बिल', dash_add_cust: 'ग्राहक जोड़ें',
    dash_rev_7: 'आय (पिछले 7 दिन)', dash_svc_cat: 'सेवा श्रेणियां',
    dash_upcoming: 'आगामी अपॉइंटमेंट', dash_view_all: 'सभी देखें',
    dash_no_billing: 'अभी तक कोई बिल नहीं। अपना पहला बिल बनाएं!',
    dash_no_upcoming: 'कोई आगामी अपॉइंटमेंट नहीं', dash_revenue: 'आय',
    access_restricted: 'पहुँच प्रतिबंधित',
    access_restricted_body: 'आपकी भूमिका ({role}) को इस पेज की अनुमति नहीं है।',
    access_stylist_hint: 'आप देख सकते हैं: डैशबोर्ड और बुकिंग',
    access_receptionist_hint: 'आप देख सकते हैं: डैशबोर्ड, बुकिंग, बिलिंग और ग्राहक',
    access_manager_hint: 'Settings छोड़कर सब कुछ',
    go_to_dashboard: '← डैशबोर्ड पर जाएं',
    my_schedule_today: 'आज मेरा शेड्यूल',
    no_bookings_today_stylist: 'आज आपके लिए कोई बुकिंग नहीं',
    bill_search: 'सेवाएं खोजें...', bill_items: 'बिल आइटम', bill_customer: 'ग्राहक',
    bill_pricing: 'मूल्य विवरण', bill_pay_method: 'भुगतान विधि',
    bill_mark_paid: 'भुगतान हुआ', bill_processing: 'प्रक्रिया में...',
    bill_subtotal: 'उपयोग', bill_discount: 'छूट',
    bill_cgst: 'सीजीएसटी (9%)', bill_sgst: 'एसजीएसटी (9%)', bill_total: 'कुल',
    bill_cash: 'नकद', bill_card: 'कार्ड', bill_upi: 'यूपीआई', bill_split: 'विभाजित',
    bill_search_cust: 'नाम या फोन से ग्राहक खोजें...',
    bill_walkin: 'या वॉक-इन के रूप में जारी रखें', bill_remove_cust: 'ग्राहक हटाएं',
    no_customer_found: '"{query}" के लिए कोई ग्राहक नहीं मिला',
    create_new_customer: '+ नया ग्राहक बनाएं',
    new_customer_title: 'नया ग्राहक',
    new_customer_save: 'सहेजें और जारी रखें',
    new_customer_created: '✓ नया ग्राहक बन गया',
    bill_success: 'भुगतान सफल!', bill_download: 'रसीद डाउनलोड करें (PDF)',
    bill_whatsapp: 'व्हाट्सएप से भेजें', bill_new: 'नया बिल',
    bill_loyalty: 'लॉयल्टी पॉइंट', bill_estimated: 'अनुमानित',
    bill_add_items: 'पहले बिल में आइटम जोड़ें', bill_complete: 'भुगतान सफलतापूर्वक पूरा!',
    bill_added: 'जोड़ा गया',
    bill_products_used: 'उपयोग किए उत्पाद (वैकल्पिक)',
    bill_product_search: 'उत्पाद खोजें...',
    bill_products_added: 'उत्पाद जोड़े',
    bill_available: 'उपलब्ध',
    bill_internal_cost: 'आंतरिक उत्पाद लागत',
    bill_ab_low_stock: 'अब कम स्टॉक में है!',
    bill_out_of_stock: 'स्टॉक खत्म हो गया!',
    bill_products_select: 'उत्पाद चुनें',
    bill_product_search_modal: 'नाम से खोजें...',
    bill_available_lower: 'उपलब्ध',
    bill_out_of_stock_label: 'स्टॉक खत्म',
    bill_products_selected: 'उत्पाद चुने',
    bill_confirm_add: 'जोड़ें',
    bill_add_more: '+ और जोड़ें',
    bill_product_cost_internal: 'उत्पाद लागत (आंतरिक)',
    served_by: 'सेवा दी',
    select_staff: 'स्टाफ चुनें...',
    not_specified: 'निर्दिष्ट नहीं',
    served_by_optional: 'वैकल्पिक — वॉक-इन के लिए छोड़ सकते हैं',
    bill_recent_bills: 'हाल के बिल',
    staff_performance_bills: 'बिल से',
    staff_performance_bookings: 'बुकिंग',
    low_stock_toast: '⚠️ {product} का स्टॉक कम हो रहा है! रिस्टॉक करें।',
    out_of_stock_toast: '🚨 {product} का स्टॉक खत्म हो गया!',
    stock_deducted: '{product} का स्टॉक अपडेट हुआ',
    cust_search: 'नाम या फोन से खोजें...', cust_add: 'ग्राहक जोड़ें',
    cust_edit: 'ग्राहक संपादित करें', cust_profile: 'ग्राहक प्रोफाइल',
    cust_visits: 'विज़िट', cust_total: 'कुल खर्च', cust_points: 'पॉइंट',
    cust_none: 'कोई ग्राहक नहीं मिला', cust_history: 'विज़िट इतिहास',
    cust_bookings: 'बुकिंग', view_bookings: 'सभी बुकिंग देखें',
    cust_no_history: 'अभी तक कोई बिलिंग इतिहास नहीं',
    cust_req: 'नाम और फोन आवश्यक हैं', cust_added: 'ग्राहक जोड़ा गया',
    cust_updated: 'ग्राहक अपडेट हुआ', cust_birthday: 'जन्मदिन', cust_gender: 'लिंग',
    cust_prefs: 'पसंद, एलर्जी आदि',
    customer_deactivate: 'निष्क्रिय करें',
    customer_deactivate_confirm_title: 'ग्राहक को निष्क्रिय करें?',
    customer_deactivate_confirm_body: 'यह ग्राहक सक्रिय सूची से हट जाएगा। उनका डेटा सुरक्षित रहेगा।',
    customer_deactivated_toast: 'ग्राहक निष्क्रिय हो गया',
    customer_reactivate: 'पुनः सक्रिय करें',
    customer_reactivated_toast: 'ग्राहक सक्रिय हो गया',
    show_inactive_customers: 'निष्क्रिय ग्राहक दिखाएं',
    customer_inactive_badge: 'निष्क्रिय',
    customer_deactivate_confirm_btn: 'हां, निष्क्रिय करें',
    customer_since: 'ग्राहक बने:',
    total_visits: 'कुल विज़िट',
    total_spent: 'कुल खर्च',
    avg_bill: 'औसत बिल',
    last_visit: 'आखिरी विज़िट',
    days_ago: '{count} दिन पहले',
    today: 'आज',
    yesterday: 'कल',
    no_visits_yet: 'कोई विज़िट नहीं',
    customer_details: 'ग्राहक विवरण',
    birthday: 'जन्मदिन',
    gender: 'लिंग',
    notes_label: 'नोट्स',
    not_provided: 'नहीं बताया',
    no_notes: 'कोई नोट्स नहीं',
    visit_history_count: 'विज़िट इतिहास ({count})',
    bookings_count: 'बुकिंग ({count})',
    load_more_visits: 'और विज़िट देखें →',
    points_to_tier: '{tier} के लिए {count} पॉइंट',
    top_customer_badge: '🏆 शीर्ष ग्राहक!',
    loyalty_points: 'लॉयल्टी पॉइंट',
    points_value: 'पॉइंट की कीमत',
    top_services: 'शीर्ष सेवाएं',
    visit_history: 'विज़िट इतिहास',
    this_month: 'इस महीने',
    this_month_visits: 'इस महीने विज़िट',
    this_month_spent: 'इस महीने खर्च',
    next_tier_progress: 'अगले टियर तक',
    top_customer: 'शीर्ष ग्राहक',
    new_bill: 'नया बिल',
    new_booking: 'नई बुकिंग',
    profile_load_error: 'प्रोफ़ाइल लोड नहीं हुई। दोबारा कोशिश करें।',
    profile_retry: 'पुनः प्रयास',
    more_visits_message: 'और विज़िट देखने के लिए रिपोर्ट्स जाएं',
    payment_cash: 'नकद',
    payment_card: 'कार्ड',
    payment_upi: 'यूपीआई',
    loyalty_earned: 'पॉइंट मिले',
    points_to_next_tier: 'अगले टियर के लिए पॉइंट चाहिए',
    how_tiers_work: 'टियर कैसे काम करते हैं ▼',
    how_tiers_work_close: 'टियर कैसे काम करते हैं ▲',
    tier_bronze: 'ब्रॉन्ज',
    tier_silver: 'सिल्वर',
    tier_gold: 'गोल्ड',
    tier_diamond: 'डायमंड',
    tier_bronze_range: '0 – 2,000 पॉइंट',
    tier_silver_range: '2,001 – 5,000 पॉइंट',
    tier_gold_range: '5,001 – 10,000 पॉइंट',
    tier_diamond_range: '10,001+ पॉइंट',
    tier_earn_rate: 'हर ₹1 खर्च = 1 पॉइंट',
    tier_redeem_info: 'पॉइंट से छूट मिल सकती है',
    pts_to_next_tier: '{tier} के लिए {count} पॉइंट चाहिए',
    top_tier_achieved: '🏆 सर्वोच्च टियर!',
    loyalty_tiers: 'लॉयल्टी टियर',
    loyalty_tiers_subtitle: 'हर टियर के लिए पॉइंट सीमा तय करें',
    tier_min_points: 'न्यूनतम पॉइंट',
    tier_max_points: 'अधिकतम पॉइंट',
    tier_min_auto: 'ऑटो',
    tier_preview: 'टियर प्रीव्यू',
    tier_badges_preview: 'टियर बैज प्रीव्यू',
    tier_threshold_error: '{higher} की सीमा {lower} से अधिक होनी चाहिए',
    how_tiers_work_link: 'ℹ️ टियर कैसे काम करते हैं →',
    tier_table_tier: 'टियर',
    svc_search: 'सेवाएं खोजें...', svc_add: 'सेवा जोड़ें', svc_edit: 'सेवा संपादित करें',
    svc_name: 'सेवा का नाम', svc_category: 'श्रेणी', svc_duration: 'अवधि (मिनट)',
    svc_price: 'मूल्य (₹)', svc_gst: 'जीएसटी दर (%)', svc_active: 'सक्रिय', svc_inactive: 'निष्क्रिय',
    svc_del_title: 'सेवा हटाएं?', svc_del_desc: 'यह कार्रवाई पूर्ववत नहीं की जा सकती।',
    svc_none: 'कोई सेवा नहीं मिली', svc_added: 'सेवा जोड़ी गई',
    svc_updated: 'सेवा अपडेट हुई', svc_deleted: 'सेवा हटाई गई',
    svc_req: 'नाम और मूल्य आवश्यक हैं',
    staff_search: 'नाम या फोन से खोजें...', staff_add: 'कर्मचारी जोड़ें', staff_edit: 'कर्मचारी संपादित करें',
    staff_role: 'भूमिका', staff_comm: 'कमीशन (%)',
    staff_in: 'क्लॉक इन', staff_out: 'क्लॉक आउट', staff_working: 'अभी काम पर',
    staff_del_title: 'कर्मचारी हटाएं?', staff_del_desc: 'यह कार्रवाई पूर्ववत नहीं की जा सकती।',
    staff_none: 'कोई कर्मचारी नहीं मिला', staff_clocked_in: 'क्लॉक इन हुआ!',
    staff_clocked_out: 'क्लॉक आउट हुआ!', staff_added: 'कर्मचारी जोड़ा गया',
    staff_updated: 'कर्मचारी अपडेट हुआ', staff_removed: 'कर्मचारी हटाया गया',
    staff_req: 'नाम और फोन आवश्यक हैं',
    staff_on_duty: 'ड्यूटी पर',
    staff_off_duty: 'ड्यूटी पर नहीं',
    staff_total: 'कुल स्टाफ',
    staff_on_duty_now: 'अभी ड्यूटी पर',
    staff_off_duty_now: 'ड्यूटी पर नहीं',
    staff_sub_team_members: 'टीम सदस्य',
    staff_sub_currently_working: 'अभी काम कर रहे',
    staff_sub_not_clocked: 'क्लॉक इन नहीं',
    staff_stat_label_today: 'आज',
    staff_stat_label_served: 'सेवा',
    monthly_hours_summary: 'मासिक घंटे सारांश',
    today_stats: 'आज के आँकड़े',
    hours_worked_today: 'घंटे काम किया',
    customers_today: 'ग्राहक सेवा दी',
    revenue_today: 'आज की कमाई',
    live_timer: 'लाइव',
    now: 'अभी',
    staff: 'स्टाफ',
    attendance: 'उपस्थिति',
    customers: 'ग्राहक',
    revenue: 'कमाई',
    commission: 'कमीशन',
    clock_in: 'क्लॉक इन',
    clock_out: 'क्लॉक आउट',
    total: 'कुल',
    joined: 'जॉइन किया',
    visits: 'विज़िट्स',
    times: 'बार',
    customers_served: 'सेवा किए ग्राहक',
    revenue_generated: 'अर्जित कमाई',
    in_progress: 'चल रहा है',
    short_day: 'कम घंटे',
    mon: 'सोम', tue: 'मंगल', wed: 'बुध', thu: 'गुरु', fri: 'शुक्र', sat: 'शनि', sun: 'रवि',
    this_week: 'इस हफ्ते',
    revenue_last_7_days: 'कमाई (पिछले 7 दिन)',
    attendance_overview: 'उपस्थिति अवलोकन',
    attendance_month_year_title: 'माह और वर्ष चुनें',
    attendance_year_label: 'वर्ष',
    attendance_month_label: 'माह',
    all_staff: 'सभी स्टाफ',
    full_day: 'पूरा दिन',
    half_day: 'आधा दिन',
    absent: 'अनुपस्थित',
    holiday: 'छुट्टी',
    no_data: 'डेटा नहीं',
    hours_today: 'आज',
    hours_this_week: 'इस हफ्ते',
    hours_this_month: 'इस महीने',
    avg_per_day: 'औसत/दिन',
    days_worked: 'दिन काम किए',
    full_days: 'पूरे दिन',
    half_days: 'आधे दिन',
    mark_holiday: 'छुट्टी मार्क करें',
    mark_absent: 'अनुपस्थित मार्क करें',
    staff_overview: 'अवलोकन',
    staff_attendance: 'उपस्थिति',
    staff_performance: 'प्रदर्शन',
    joining_date: 'जॉइनिंग तारीख',
    all_time_hours: 'कुल घंटे',
    days_present: 'उपस्थित दिन',
    days_absent: 'अनुपस्थित दिन',
    book_new: 'नई बुकिंग', book_today: 'आज',
    book_none: 'इस दिन कोई बुकिंग नहीं', book_first: 'पहली बुकिंग बनाएं',
    book_customer: 'ग्राहक', book_services: 'सेवाएं',
    book_stylist: 'स्टाइलिस्ट', book_time: 'समय', book_notes: 'नोट्स',
    book_confirm: 'पुष्टि करें', book_start: 'शुरू करें', book_complete: 'पूर्ण करें',
    book_cancel: 'रद्द करें', book_del_title: 'बुकिंग हटाएं?',
    book_del_desc: 'यह कार्रवाई पूर्ववत नहीं की जा सकती।',
    book_any: 'कोई भी उपलब्ध', book_special: 'कोई विशेष अनुरोध...',
    book_created: 'बुकिंग बनाई गई', book_deleted: 'बुकिंग हटाई गई',
    book_req: 'ग्राहक और कम से कम एक सेवा आवश्यक है',
    book_search_cust: 'ग्राहक खोजें...', book_create: 'बुकिंग बनाएं',
    book_new_for: 'नई बुकिंग -',
    booking_scheduled: 'निर्धारित',
    booking_completed: 'पूर्ण',
    booking_cancelled: 'रद्द',
    booking_no_show: 'नहीं आए',
    booking_complete_btn: 'पूर्ण करें',
    booking_no_show_btn: 'नहीं आए',
    booking_cancel_btn: 'रद्द करें',
    booking_edit_btn: 'संपादित करें',
    booking_create_bill: 'बिल बनाएं →',
    booking_past_date_warning: 'आप पुरानी तारीख के लिए बुकिंग कर रहे हैं।',
    booking_past_time_warning: 'यह समय बीत चुका है। पुरानी बुकिंग दर्ज करने के लिए जारी रखें।',
    booking_cancel_confirm_title: 'बुकिंग रद्द करें?',
    booking_cancel_confirm_body: 'यह बुकिंग रद्द हो जाएगी।',
    booking_cancel_confirm_btn: 'हाँ, रद्द करें',
    booking_keep_btn: 'बुकिंग रखें',
    booking_noshow_confirm_title: 'नो शो मार्क करें?',
    booking_noshow_confirm_body: '{name} अपॉइंटमेंट पर नहीं आए?',
    booking_noshow_confirm_btn: 'हाँ, नहीं आए',
    booking_update_btn: 'बुकिंग अपडेट करें',
    edit_booking_title: 'बुकिंग संपादित करें',
    no_bookings_today: '{date} के लिए कोई बुकिंग नहीं',
    no_filtered_bookings: '{date} के लिए कोई {status} बुकिंग नहीं',
    booking_filter_all: 'सभी',
    booking_filter_scheduled: 'निर्धारित',
    booking_filter_completed: 'पूर्ण',
    booking_filter_cancelled: 'रद्द',
    booking_filter_no_show: 'नहीं आए',
    booking_new_customer_phone: 'फोन (नया ग्राहक)',
    booking_new_customer_phone_placeholder: '10 अंकों का फोन नंबर',
    booking_new_customer_phone_required: 'नया ग्राहक बनाने के लिए फोन जरूरी है',
    lang_title: 'भाषा',
    rpt_title: 'रिपोर्ट और विश्लेषण',
    rpt_subtitle: 'अपने सैलून की ग्रोथ एक जगह ट्रैक करें',
    rpt_total_revenue: 'कुल राजस्व',
    rpt_total_bookings: 'कुल बुकिंग',
    rpt_new_customers: 'नए ग्राहक',
    rpt_avg_bill_value: 'औसत बिल',
    rpt_revenue_trend: 'राजस्व ट्रेंड',
    rpt_top_services: 'शीर्ष सेवाएं',
    rpt_payment_methods: 'भुगतान तरीके',
    rpt_staff_performance: 'स्टाफ प्रदर्शन',
    rpt_customer_insights: 'ग्राहक जानकारी',
    rpt_returning_vs_new: 'लौटने वाले vs नए ग्राहक',
    rpt_peak_hours: 'पीक घंटे',
    rpt_export: 'निर्यात',
    rpt_no_data: 'इस अवधि में कोई डेटा नहीं',
    rpt_today: 'आज',
    rpt_this_week: 'इस हफ्ते',
    rpt_this_month: 'इस महीने',
    rpt_custom: 'कस्टम',
    rpt_appointments: 'अपॉइंटमेंट',
    rpt_revenue_generated: 'अर्जित राजस्व',
    rpt_commission_earned: 'कमीशन',
    rpt_top_service: 'शीर्ष सेवा',
    rpt_cash: 'नकद',
    rpt_card: 'कार्ड',
    rpt_upi: 'यूपीआई',
    rpt_select_start_date: 'शुरू की तारीख',
    rpt_select_end_date: 'अंत की तारीख',
    rpt_apply: 'लागू करें',
    rpt_export_csv: 'CSV निर्यात',
    rpt_export_pdf: 'PDF निर्यात',
    rpt_export_excel: 'Excel निर्यात',
    rpt_share_report: 'रिपोर्ट शेयर करें',
    rpt_staff: 'स्टाफ',
    rpt_revenue: 'राजस्व',
    rpt_bookings: 'बुकिंग',
    rpt_reports_load_error: 'रिपोर्ट लोड नहीं हुई',
    rpt_export_no_data: 'निर्यात के लिए डेटा नहीं',
    rpt_export_csv_done: 'CSV निर्यात हो गया',
    rpt_times_booked: 'बार बुक हुआ',
    rpt_product_usage: 'उत्पाद उपयोग (लागत)',
    rpt_product_name: 'उत्पाद',
    rpt_quantity_used: 'मात्रा इस्तेमाल',
    rpt_total_cost: 'कुल लागत',
    rpt_returning: 'लौटने वाले',
    rpt_new: 'नए',
    rpt_summary_copied: 'सार क्लिपबोर्ड में कॉपी हो गया!',
    rpt_payment: 'भुगतान',
    rpt_customers: 'ग्राहक',
    rpt_date: 'तारीख',
    rpt_period: 'अवधि',
    rpt_service: 'सेवा',
    rpt_name: 'नाम',
    rpt_role: 'भूमिका',
    rpt_generated_by: 'SalonSync द्वारा जनरेट',
    rpt_generated_on: 'जनरेट की तारीख',
    settings: 'सेटिंग्स',
    settings_salon_profile: 'सैलून प्रोफ़ाइल',
    settings_notifications: 'सूचनाएं',
    settings_billing: 'बिलिंग सेटिंग्स',
    settings_user_mgmt: 'यूज़र प्रबंधन',
    settings_data_backup: 'डेटा और बैकअप',
    settings_salon_name: 'सैलून का नाम',
    settings_phone: 'फ़ोन',
    settings_email: 'ईमेल',
    settings_address: 'पता',
    settings_gst: 'GST नंबर',
    settings_website: 'वेबसाइट',
    settings_save: 'बदलाव सेव करें',
    settings_saved: 'सेटिंग्स सेव हो गई!',
    settings_inv_prefix: 'इनवॉइस प्रीफिक्स',
    settings_next_inv: 'अगला इनवॉइस नंबर',
    settings_loyalty_per_rupee: 'प्रति ₹ लॉयल्टी पॉइंट',
    settings_redemption_per_point: 'प्रति पॉइंट ₹ रिडेम्पशन',
    notif_booking_title: 'बुकिंग कन्फर्मेशन ऑटो भेजें',
    notif_booking_sub: 'बुकिंग बनने पर WhatsApp भेजें',
    notif_bill_title: 'बिल WhatsApp पर ऑटो भेजें',
    notif_bill_sub: 'पेमेंट के बाद रसीद WhatsApp पर भेजें',
    notif_birthday_title: 'जन्मदिन की बधाई',
    notif_birthday_sub: 'ग्राहक के जन्मदिन पर ऑटो संदेश भेजें',
    notif_reminder_title: 'अपॉइंटमेंट रिमाइंडर',
    notif_reminder_sub: 'अपॉइंटमेंट से पहले रिमाइंडर भेजें',
    whatsapp_note: 'इंटीग्रेशन के लिए WhatsApp Business API जरूरी है। अभी WhatsApp Web से मैन्युअली काम करता है।',
    email_config: 'ईमेल कॉन्फ़िगरेशन',
    resend_api_key: 'Resend API Key',
    resend_api_key_help: 'resend.com पर फ्री API key पाएं',
    resend_open: 'Resend खोलें ↗',
    resend_api_key_placeholder: 're_xxxxxxxxxxxxxxxx',
    resend_api_key_invalid: 'गलत फॉर्मेट। Key re_ से शुरू होनी चाहिए',
    resend_used_for: 'उपयोग: पासवर्ड रीसेट, बुकिंग, रसीद',
    test_email: 'टेस्ट ईमेल भेजें',
    test_email_sending: 'भेज रहे हैं...',
    test_email_success: 'टेस्ट ईमेल गया! इनबॉक्स चेक करें।',
    test_email_failed: 'फेल। API key चेक करें।',
    resend_key_saved: 'ईमेल सेटिंग्स सेव हुई',
    using_system_email: 'सिस्टम डिफ़ॉल्ट ईमेल उपयोग हो रहा है',
    settings_field_required: 'आवश्यक है',
    settings_user_req: 'नाम और ईमेल आवश्यक',
    settings_user_updated: 'यूज़र अपडेट हो गया',
    settings_user_added: 'यूज़र जोड़ा गया',
    settings_backup_complete: 'बैकअप पूरा! 4 फ़ाइलें डाउनलोड हुईं।',
    settings_backup_failed: 'बैकअप विफल',
    settings_try_again: 'कृपया पुनः प्रयास करें',
    settings_restore_success: 'डेटा पुनर्स्थापित हो गया!',
    settings_restore_unknown: 'अज्ञात फ़ाइल प्रकार। ग्राहक, बुकिंग, सेवा या स्टाफ CSV का उपयोग करें।',
    settings_users_demo: 'यह फीचर अभी डेमो मोड में है। रियल लॉगिन सिस्टम जल्द आ रहा है।',
    settings_table_user: 'यूज़र',
    settings_table_role: 'भूमिका',
    settings_table_status: 'स्थिति',
    settings_table_actions: 'कार्रवाई',
    settings_add_user: 'यूज़र जोड़ें',
    settings_backup_full: 'पूर्ण बैकअप CSV में',
    settings_restore_btn: 'बैकअप से पुनर्स्थापित करें',
    settings_last_backup: 'अंतिम बैकअप',
    settings_never: 'कभी नहीं',
    settings_edit_user: 'यूज़र संपादित करें',
    settings_password_keep: '(रखने के लिए खाली छोड़ें)',
    settings_update: 'अपडेट',
    settings_add_karo: 'जोड़ें',
    settings_restore_title: 'बैकअप से पुनर्स्थापित करें',
    settings_restore_confirm: 'पुनर्स्थापित करने से सारा वर्तमान डेटा बदल जाएगा। क्या आप सुनिश्चित हैं?',
    settings_restore_yes: 'हां, पुनर्स्थापित करें',
    settings_password: 'पासवर्ड',
    settings_status_active: 'सक्रिय',
    settings_status_inactive: 'निष्क्रिय',
    settings_you_badge: 'आप',
    settings_password_optional_hint: 'पासवर्ड नहीं बदलना? खाली छोड़ें',
    settings_confirm_password: 'पासवर्ड की पुष्टि करें',
    settings_deactivate_confirm: 'इस यूज़र को डिएक्टिवेट करें?',
    settings_deactivate: 'डिएक्टिवेट',
    settings_users_load_error: 'यूज़र लोड नहीं हुए',
    inv_total_products: 'कुल उत्पाद',
    inv_low_stock: 'कम स्टॉक',
    inv_inventory_value: 'इन्वेंटरी मूल्य',
    inv_product_add: 'उत्पाद जोड़ें',
    inv_product_search: 'उत्पाद खोजें...',
    inv_filter_all: 'सभी',
    inv_filter_low_stock: 'कम स्टॉक',
    inv_filter_out_of_stock: 'स्टॉक खत्म',
    inv_min_threshold: 'न्यूनतम सीमा',
    inv_cost_price: 'लागत मूल्य',
    inv_brand: 'ब्रांड',
    inv_stock_history: 'स्टॉक इतिहास',
    inv_stock_add: 'स्टॉक बढ़ाएं',
    inv_stock_reduce: 'स्टॉक घटाएं',
    inv_update_karo: 'अपडेट करें',
    inv_reason_new_stock: 'नया स्टॉक',
    inv_reason_return: 'वापसी',
    inv_reason_correction: 'सुधार',
    inv_reason_used: 'सेवा में उपयोग',
    inv_reason_damaged: 'खराब',
    inv_reason_expired: 'एक्सपायर',
    inv_products_low_stock: 'उत्पाद कम स्टॉक में हैं',
    inv_whatsapp_alert: 'WhatsApp अलर्ट भेजें',
    inv_low_stock_alert: 'कम स्टॉक अलर्ट',
    inv_restock_karo: 'रिस्टॉक करें',
    inv_stock_updated: 'स्टॉक अपडेट हो गया!',
    inv_dismiss: 'बंद करें',
    inv_clear_history: 'इतिहास साफ़ करें',
    inv_low_stock_in: 'कम स्टॉक में है',
    inv_save_karo: 'सहेजें',
    inv_min_alert_helper: 'इससे कम होने पर अलर्ट मिलेगा',
    inv_current_stock: 'वर्तमान स्टॉक',
    inv_product_name: 'उत्पाद का नाम',
    inv_category: 'श्रेणी',
    inv_unit: 'इकाई',
    inv_type: 'प्रकार',
    inv_quantity: 'मात्रा',
    inv_reason: 'कारण',
    inv_time: 'समय',
    inv_clear_confirm: 'इतिहास साफ करें?',
    inv_del_title: 'उत्पाद हटाएं?',
    inv_del_desc: 'यह कार्रवाई पूर्ववत नहीं की जा सकती।',
    inv_none: 'कोई उत्पाद नहीं मिला',
    inv_add_stock: '+ स्टॉक जोड़ें',
    inv_stock_btn: 'स्टॉक',
    inv_product: 'उत्पाद',
    use_tracking: 'उपयोग-आधारित ट्रैकिंग',
    use_per_unit: 'प्रति {unit} उपयोग',
    use_name: 'उपयोग का नाम',
    use_stroke: 'स्ट्रोक',
    use_pump: 'पंप',
    use_spray: 'स्प्रे',
    use_scoop: 'स्कूप',
    use_available: 'स्ट्रोक उपलब्ध',
    use_alert_below: 'अलर्ट सीमा (उपयोग)',
    use_bottles_added: 'बोतलें जोड़ी = {x} स्ट्रोक जोड़े',
    use_one_call: 'एक उपयोग को क्या कहेंगे?',
    use_stock_label: 'उपयोग-आधारित स्टॉक',
    use_per_use: 'प्रति उपयोग',
    use_modal_helper: 'कंटेनर में कितने उपयोग?',
    use_alert_helper: 'कितने उपयोग बचें तो अलर्ट?',
    use_status: '{x} {useUnit} उपलब्ध, {y} {unit} में',
    use_kitni_units: 'कितनी {units} जोड़ी?',
    use_kitne_use: 'कितने {useUnit} उपयोग हुए?',
    use_added_msg: '{units} जोड़ी = {x} {useUnit} जोड़े',
    val_name_min: 'At least 2 characters required',
    val_name_max: 'Maximum 100 characters',
    val_stock_min: 'Must be 0 or more',
    val_stock_number: 'Must be a number',
    val_uses_required: 'Required when use-based tracking is on',
    val_uses_min: 'At least 1 required',
    val_phone_10: 'Exactly 10 digits required',
    val_phone_numbers: 'Numbers only',
    val_email_invalid: 'Enter a valid email or leave empty',
    val_customer_or_walkin: 'Select a customer or continue as walk-in',
    val_services_one: 'Select at least one service',
    val_date_past: 'Date/time is in the past',
    val_payment_method: 'Select payment method',
    del_confirm_title: 'Delete karna chahte hain?',
    del_confirm_desc: 'Ye action undo nahi ho sakta.',
    del_confirm_btn: 'Haan, Delete Karo',
    del_cancel: 'Cancel',
    notifications: 'सूचनाएं',
    mark_all_read: 'सभी पढ़े मार्क करें',
    no_notifications: 'कोई सूचना नहीं',
    low_stock_notif: 'लो स्टॉक',
    new_booking_notif: 'नई बुकिंग',
    payment_notif: 'भुगतान',
    system_notif: 'सिस्टम',
    my_profile: 'मेरी प्रोफ़ाइल',
    change_password: 'पासवर्ड बदलें',
    current_password: 'वर्तमान पासवर्ड',
    new_password: 'नया पासवर्ड',
    confirm_new_password: 'पासवर्ड कन्फर्म करें',
    password_changed: 'पासवर्ड बदल गया',
    logout_confirm: 'लॉगआउट करना चाहते हैं?',
    logout_confirm_title: 'लॉगआउट करें?',
    just_now: 'अभी',
    min_ago: 'मिनट पहले',
    hour_ago: 'एक घंटा पहले',
    hours_ago: 'घंटे पहले',
    view_inventory: 'इन्वेंटरी देखें',
    view_bookings: 'बुकिंग देखें',
    older_notifications: 'पुरानी सूचनाएं',
    notif_select: 'चुनें',
    notif_selected: 'selected',
    notif_delete_selected: 'चुनी हुई delete करें',
    notif_delete_all: 'सब delete करें',
    notif_delete_all_confirm_title: 'सारी notifications delete करें?',
    notif_delete_all_confirm_body: 'यह undo नहीं होगा।',
    notif_delete_all_confirm_btn: 'हाँ, सब हटाएं',
    notif_deleted: 'Notification delete हुई',
    notif_deleted_count: '{count} सूचनाएं हटाई गईं',
    notif_delete_single_confirm: 'यह notification delete करें?',
    payment_received: 'भुगतान मिला',
    new_customer_added: 'नया ग्राहक जोड़ा',
    new_staff_added: 'नया स्टाफ जोड़ा',
    staff_clock_in_notif: 'स्टाफ ने काम शुरू किया',
    staff_clock_out_notif: 'स्टाफ ने काम खत्म किया',
    new_product_added: 'नया प्रोडक्ट जोड़ा',
    stock_updated: 'स्टॉक अपडेट हुआ',
    new_service_added: 'नई सेवा जोड़ी',
    settings_updated_notif: 'सेटिंग्स अपडेट हुई',
    select_cancel: 'रद्द करें',
    hours_worked: 'घंटे काम किया',
    notif_low_stock_title: 'कम स्टॉक अलर्ट',
    notif_low_stock_message: '{product} का स्टॉक कम हो रहा है',
    notif_payment_title: 'भुगतान मिला',
    notif_payment_message: '{customer} - ₹{amount} {method} से मिला',
    notif_walkin_payment_message: 'वॉक-इन - ₹{amount} {method} से मिला',
    notif_new_customer_title: 'नया ग्राहक जोड़ा',
    notif_new_customer_message: '{name} का अकाउंट बना',
    notif_new_staff_title: 'नया स्टाफ जोड़ा',
    notif_new_staff_message: '{name} ({role}) को जोड़ा गया',
    notif_clock_in_title: 'स्टाफ ने काम शुरू किया',
    notif_clock_in_message: '{name} ने आज काम शुरू किया',
    notif_clock_out_title: 'स्टाफ ने काम खत्म किया',
    notif_clock_out_message: '{name} ने आज {hours} घंटे काम किया',
    notif_new_product_title: 'नया प्रोडक्ट जोड़ा',
    notif_new_product_message: '{name} इन्वेंटरी में जोड़ा गया',
    notif_stock_updated_title: 'स्टॉक अपडेट हुआ',
    notif_stock_updated_message: '{name} में {quantity} {unit} जोड़े',
    notif_new_service_title: 'नई सेवा जोड़ी',
    notif_new_service_message: '{name} - ₹{price} जोड़ी',
    notif_new_booking_title: 'नई बुकिंग',
    notif_new_booking_message: '{customer} की बुकिंग {time} पर',
    notif_settings_title: 'सेटिंग्स अपडेट हुई',
    notif_settings_message: 'सैलून प्रोफ़ाइल अपडेट हो गई',
    notif_welcome_title: 'SalonSync में आपका स्वागत है!',
    notif_welcome_message: 'सेटअप पूरा हुआ। सेवाएं, स्टाफ जोड़ें और बिलिंग शुरू करें!',
    loading: 'लोड हो रहा है...',
    delete_failed: 'डिलीट विफल',
    password_mismatch: 'पासवर्ड मेल नहीं खाते',
    password_required: 'वर्तमान पासवर्ड आवश्यक है',
    password_update_failed: 'पासवर्ड अपडेट विफल',
    dash_load_error: 'डैशबोर्ड डेटा लोड नहीं हुआ',
    book_load_error: 'बुकिंग लोड नहीं हुई',
    book_create_error: 'बुकिंग बनाने में विफल',
    book_status_error: 'स्टेटस अपडेट विफल',
    update_failed: 'अपडेट नहीं हो पाया',
    book_delete_error: 'डिलीट विफल',
    book_whatsapp_confirm: 'क्या आप WhatsApp पर कन्फर्मेशन भेजना चाहेंगे?',
    book_status_updated: 'बुकिंग {status}',
    book_whatsapp_coming_soon: 'WhatsApp रिमाइंडर: जल्द आ रहा है!',
    settings_load_error: 'सेटिंग्स लोड नहीं हुई',
    settings_save_error: 'सेव विफल',
    cust_load_error: 'ग्राहक लोड नहीं हुए',
    cust_save_error: 'ग्राहक सेव विफल',
    cust_edit_load_error: 'संपादन के लिए ग्राहक लोड नहीं हुआ',
    cust_deactivate_error: 'निष्क्रिय करने में विफल',
    cust_reactivate_error: 'पुनः सक्रिय करने में विफल',
    bill_payment_failed: 'भुगतान विफल। कृपया पुनः प्रयास करें।',
    bill_receipt_downloaded: 'रसीद PDF डाउनलोड हो गई',
    bill_whatsapp_coming_soon: 'WhatsApp इंटीग्रेशन जल्द आ रहा है!',
    svc_load_error: 'सेवाएं लोड नहीं हुई',
    svc_save_error: 'सेवा सेव विफल',
    svc_delete_error: 'सेवा हटाने में विफल',
    staff_load_error: 'स्टाफ लोड नहीं हुए',
    staff_save_error: 'स्टाफ सेव विफल',
    staff_clock_in_error: 'क्लॉक इन विफल',
    staff_clock_out_error: 'क्लॉक आउट विफल',
    staff_delete_error: 'स्टाफ हटाने में विफल',
    app_access: 'ऐप एक्सेस',
    give_app_access: 'SalonSync ऐप एक्सेस दें',
    app_access_enabled: 'ऐप एक्सेस चालू है',
    app_access_disabled: 'ऐप एक्सेस नहीं है',
    app_access_card_active: 'सक्रिय',
    app_access_card_off: 'चालू नहीं',
    app_access_no_access: 'कोई एक्सेस नहीं',
    app_access_active_line: 'सक्रिय — {email}',
    app_access_optional_section: 'ऐप एक्सेस (वैकल्पिक)',
    app_access_cannot_login: 'स्टाफ सदस्य SalonSync में लॉगिन नहीं कर पाएगा।',
    app_access_login_blurb: 'वे इन क्रेडेंशियल से लॉगिन करेंगे। भूमिका: {role} — {access}',
    enable_login: 'लॉगिन चालू करें',
    disable_login: 'एक्सेस हटाएं',
    change_password: 'पासवर्ड बदलें',
    login_email: 'लॉगिन ईमेल',
    login_password: 'लॉगिन पासवर्ड',
    login_password_placeholder: 'कम से कम 8 अक्षर',
    staff_app_access_title: 'स्टाफ ऐप एक्सेस',
    staff_app_access_subtitle: 'कौन लॉगिन कर सकता है और क्या देख सकता है, यह प्रबंधित करें',
    add_staff_member: 'स्टाफ जोड़ें',
    staff_table_member: 'स्टाफ सदस्य',
    staff_has_app_access_email: 'ऐप एक्सेस है ({email})',
    remove_app_access_confirm: 'वे अब साइन इन नहीं कर पाएंगे। बाद में फिर से एक्सेस चालू कर सकते हैं।',
    role_access_owner: 'पूर्ण एक्सेस',
    role_access_manager: 'सेटिंग्स को छोड़कर सब',
    role_access_receptionist: 'बुकिंग, बिलिंग, ग्राहक',
    role_access_stylist: 'केवल बुकिंग',
    auth_failed: 'प्रमाणीकरण विफल',
    demo_loaded: 'डेमो डेटा लोड! owner@salonsync.com / admin123 से लॉगिन करें',
    demo_load_error: 'डेमो डेटा लोड विफल',
    login_welcome_toast: 'स्वागत है, {name}!',
    login_welcome_back_toast: 'वापस स्वागत है, {name}!',
  },
  gu: {
    nav_dashboard: 'ડેશબોર્ડ', nav_bookings: 'બુકિંગ', nav_billing: 'બિલિંગ',
    nav_customers: 'ગ્રાહકો', nav_services: 'સેવાઓ', nav_staff: 'કર્મચારીઓ', nav_inventory: 'ઇન્વેન્ટરી', nav_reports: 'રિપોર્ટ્સ', nav_logout: 'લૉગ આઉટ',
    search: 'શોધો', save: 'સાચવો', saving: 'સાચવી રહ્યા છે...', cancel: 'રદ કરો', delete: 'કાઢી નાખો',
    remove: 'દૂર કરો', edit: 'ફેરફાર કરો', add: 'ઉમેરો', confirm: 'ખાતરી કરો', close: 'બંધ કરો',
    name: 'નામ', phone: 'ફોન', email: 'ઈમેઇલ', notes: 'નોંધ',
    login_welcome: 'ફરી સ્વાગત છે', login_subtitle: 'તમારા સલૂનનું સંચાલન કરો',
    login_create: 'ખાતું બનાવો', login_create_sub: 'મિનિટોમાં તમારું સલૂન સેટઅપ કરો',
    login_your_name: 'તમારું નામ', login_salon_name: 'સલૂનનું નામ',
    login_sign_in: 'સાઇન ઇન', login_sign_up: 'ખાતું બનાવો',
    login_no_account: 'ખાતું નથી? સાઇન અપ કરો',
    login_have_account: 'પહેલેથી ખાતું છે? સાઇન ઇન કરો',
    auth_session_expired: 'Session expire ho gayi. Dobara login karein.',
    errb_title: 'કંઈક ગડબડ થઈ ગઈ',
    errb_subtitle: 'Something went wrong',
    errb_retry: 'ફરી ટ્રાય કરો',
    errb_logged: 'Error has been logged.',
    offline_banner: 'ઇન્ટરનેટ નથી — ફેરફાર સેવ નહીં થાય',
    offline_toast_restored: 'ઇન્ટરનેટ પાછું આવી ગયું!',
    login_load_demo: 'ડેમો ડેટા લોડ કરો', login_demo_desc: 'સેમ્પલ સેવાઓ, કર્મચારીઓ અને ગ્રાહકો સેટઅપ કરો',
    login_tagline: 'તમારું સંપૂર્ણ સલૂન\nમેનેજમેન્ટ સોલ્યુશન',
    login_tagline_desc: 'બુકિંગ, બિલિંગ, કર્મચારીઓ અને ગ્રાહકો — બધું એક એપમાં.',
    login_enter_name: 'તમારું નામ દાખલ કરો', login_enter_email: 'you@example.com',
    login_enter_pass: 'પાસવર્ડ દાખલ કરો', login_enter_salon: 'દા.ત. ગ્લેમર સ્ટુડિયો',
    email: 'ઇમેઇલ', password: 'પાસવર્ડ', your_name: 'તમારું નામ', salon_name: 'સલૂનનું નામ',
    confirm_password: 'પાસવર્ડ કન્ફર્મ કરો', sign_in: 'સાઇન ઇન', create_account: 'એકાઉન્ટ બનાવો',
    signing_in: 'સાઇન ઇન થઈ રહ્યા છીએ...', creating_account: 'એકાઉન્ટ બની રહ્યું છે...',
    invalid_credentials: 'ખોટો ઇમેઇલ અથવા પાસવર્ડ', already_have_account: 'પહેલેથી એકાઉન્ટ છે?',
    dont_have_account: 'એકાઉન્ટ નથી?', sign_up: 'સાઇન અપ', sign_in_link: 'સાઇન ઇન',
    welcome_back: 'પાછા આવ્યા, સ્વાગત છે', sign_in_subtitle: 'તમારો સલૂન મૅનેજ કરો',
    create_account_subtitle: 'મિનિટોમાં સેટઅપ કરો', forgot_password: 'પાસવર્ડ ભૂલ્યા?',
    password_strength: 'પાસવર્ડ મજબૂતી', strength_weak: 'નબળો', strength_fair: 'ઠીક', strength_good: 'સારો', strength_strong: 'મજબૂત',
    val_email_required: 'ઇમેઇલ જરૂરી છે', val_email_invalid: 'માન્ય ઇમેઇલ દાખલ કરો',
    val_password_required: 'પાસવર્ડ જરૂરી છે', val_password_min: 'પાસવર્ડ ઓછામાં ઓછો 8 અક્ષરનો હોવો જોઈએ', val_password_min_login: 'પાસવર્ડ ઓછામાં ઓછો 6 અક્ષરનો હોવો જોઈએ',
    val_name_required: 'નામ જરૂરી છે', val_name_min: 'નામ ઓછામાં ઓછું 2 અક્ષરનું હોવું જોઈએ',
    val_salon_required: 'સલૂનનું નામ જરૂરી છે', val_passwords_match: 'પાસવર્ડ મેળ નથી ખાતા',
    forgot_title: 'પાસવર્ડ ભૂલ્યા?',
    forgot_body: 'તમારા SalonSync એડમિનને પાસવર્ડ રીસેટ કરવા કહો.',
    forgot_hint: 'એડમિન Settings → User Management થી પાસવર્ડ બદલી શકે છે',
    back_to_login: '← લૉગિન પર પાછા',
    dash_morning: 'શુભ સવાર', dash_afternoon: 'શુભ બપોર', dash_evening: 'શુભ સાંજ',
    dash_today_rev: 'આજની આવક', dash_today_book: 'આજના બુકિંગ',
    dash_new_cust: 'નવા ગ્રાહકો', dash_top_svc: 'ટોચની સેવા',
    dash_pending: 'બાકી', dash_this_month: 'આ મહિને',
    dash_new_booking: 'નવું બુકિંગ', dash_new_bill: 'નવું બિલ', dash_add_cust: 'ગ્રાહક ઉમેરો',
    dash_rev_7: 'આવક (છેલ્લા 7 દિવસ)', dash_svc_cat: 'સેવા શ્રેણીઓ',
    dash_upcoming: 'આગામી એપોઇન્ટમેન્ટ', dash_view_all: 'બધા જુઓ',
    dash_no_billing: 'હજી કોઈ બિલ નથી. તમારું પહેલું બિલ બનાવો!',
    dash_no_upcoming: 'કોઈ આગામી એપોઇન્ટમેન્ટ નથી', dash_revenue: 'આવક',
    access_restricted: 'ઍક્સેસ પ્રતિબંધિત',
    access_restricted_body: 'તમારી ભૂમિકા ({role}) ને આ પેજ જોવાની પરવાનગી નથી.',
    access_stylist_hint: 'તમે જોઈ શકો: ડૅશબોર્ડ અને બુકિંગ',
    access_receptionist_hint: 'તમે જોઈ શકો: ડૅશબોર્ડ, બુકિંગ, બિલિંગ અને ગ્રાહકો',
    access_manager_hint: 'Settings સિવાય બધું',
    go_to_dashboard: '← ડૅશબોર્ડ પર જાઓ',
    my_schedule_today: 'આજનો મારો શેડ્યૂલ',
    no_bookings_today_stylist: 'આજ તમારા માટે કોઈ બુકિંગ નથી',
    bill_search: 'સેવાઓ શોધો...', bill_items: 'બિલ આઇટમ', bill_customer: 'ગ્રાહક',
    bill_pricing: 'કિંમત વિગત', bill_pay_method: 'ચુકવણી પદ્ધતિ',
    bill_mark_paid: 'ચુકવણી થઈ', bill_processing: 'પ્રક્રિયામાં...',
    bill_subtotal: 'પેટાકુલ', bill_discount: 'છૂટ',
    bill_cgst: 'સીજીએસટી (9%)', bill_sgst: 'એસજીએસટી (9%)', bill_total: 'કુલ',
    bill_cash: 'રોકડ', bill_card: 'કાર્ડ', bill_upi: 'યુપીઆઈ', bill_split: 'વિભાજિત',
    bill_search_cust: 'નામ અથવા ફોનથી ગ્રાહક શોધો...',
    bill_walkin: 'અથવા વૉક-ઇન તરીકે ચાલુ રાખો', bill_remove_cust: 'ગ્રાહક દૂર કરો',
    no_customer_found: '"{query}" માટે કોઈ ગ્રાહક મળ્યો નથી',
    create_new_customer: '+ નવો ગ્રાહક બનાવો',
    new_customer_title: 'નવો ગ્રાહક',
    new_customer_save: 'સાચવો અને ચાલુ રાખો',
    new_customer_created: '✓ નવો ગ્રાહક બન્યો',
    bill_success: 'ચુકવણી સફળ!', bill_download: 'રસીદ ડાઉનલોડ કરો (PDF)',
    bill_whatsapp: 'વ્હોટ્સએપ દ્વારા મોકલો', bill_new: 'નવું બિલ',
    bill_loyalty: 'લોયલ્ટી પોઈન્ટ', bill_estimated: 'અંદાજિત',
    bill_add_items: 'પહેલા બિલમાં આઇટમ ઉમેરો', bill_complete: 'ચુકવણી સફળતાપૂર્વક પૂર્ણ!',
    bill_added: 'ઉમેર્યું',
    bill_products_used: 'વપરાયેલ ઉત્પાદો (વૈકલ્પિક)',
    bill_product_search: 'ઉત્પાદ શોધો...',
    bill_products_added: 'ઉત્પાદ ઉમેર્યા',
    bill_available: 'ઉપલબ્ધ',
    bill_internal_cost: 'આંતરિક ઉત્પાદ ખર્ચ',
    bill_ab_low_stock: 'હવે ઓછા સ્ટૉકમાં છે!',
    bill_out_of_stock: 'સ્ટૉક ખતમ થઈ ગયો!',
    bill_products_select: 'ઉત્પાદ પસંદ કરો',
    bill_product_search_modal: 'નામ શોધો...',
    bill_available_lower: 'ઉપલબ્ધ',
    bill_out_of_stock_label: 'સ્ટૉક ખતમ',
    bill_products_selected: 'ઉત્પાદ પસંદ',
    bill_confirm_add: 'ઉમેરો',
    bill_add_more: '+ વધુ ઉમેરો',
    bill_product_cost_internal: 'ઉત્પાદ ખર્ચ (આંતરિક)',
    served_by: 'સેવા આપી',
    select_staff: 'સ્ટાફ પસંદ કરો...',
    not_specified: 'નિર્દિષ્ટ નહીં',
    served_by_optional: 'વૈકલ્પિક — વૉક-ઇન માટે છોડી શકાય',
    bill_recent_bills: 'તાજેતરના બિલ',
    staff_performance_bills: 'બિલ થી',
    staff_performance_bookings: 'બુકિંગ',
    low_stock_toast: '⚠️ {product} નો સ્ટૉક ઓછો થઈ રહ્યો છે! રિસ્ટૉક કરો.',
    out_of_stock_toast: '🚨 {product} નો સ્ટૉક ખતમ થઈ ગયો!',
    stock_deducted: '{product} નો સ્ટૉક અપડેટ થયો',
    cust_search: 'નામ અથવા ફોનથી શોધો...', cust_add: 'ગ્રાહક ઉમેરો',
    cust_edit: 'ગ્રાહક ફેરફાર કરો', cust_profile: 'ગ્રાહક પ્રોફાઇલ',
    cust_visits: 'મુલાકાતો', cust_total: 'કુલ ખર્ચ', cust_points: 'પોઈન્ટ',
    cust_none: 'કોઈ ગ્રાહક મળ્યા નથી', cust_history: 'મુલાકાત ઇતિહાસ',
    cust_bookings: 'બુકિંગ', view_bookings: 'બધી બુકિંગ જુઓ',
    cust_no_history: 'હજી કોઈ બિલિંગ ઇતિહાસ નથી',
    cust_req: 'નામ અને ફોન જરૂરી છે', cust_added: 'ગ્રાહક ઉમેરાયા',
    cust_updated: 'ગ્રાહક અપડેટ થયા', cust_birthday: 'જન્મદિવસ', cust_gender: 'લિંગ',
    cust_prefs: 'પસંદગીઓ, એલર્જી વગેરે',
    customer_deactivate: 'નિષ્ક્રિય કરો',
    customer_deactivate_confirm_title: 'ગ્રાહકને નિષ્ક્રિય કરો?',
    customer_deactivate_confirm_body: 'આ ગ્રાહક સક્રિય સૂચિમાંથી હટી જશે. તેમનો ડેટા સુરક્ષિત રહેશે.',
    customer_deactivated_toast: 'ગ્રાહક નિષ્ક્રિય થઈ ગયો',
    customer_reactivate: 'ફરી સક્રિય કરો',
    customer_reactivated_toast: 'ગ્રાહક સક્રિય થઈ ગયો',
    show_inactive_customers: 'નિષ્ક્રિય ગ્રાહકો બતાવો',
    customer_inactive_badge: 'નિષ્ક્રિય',
    customer_deactivate_confirm_btn: 'હા, નિષ્ક્રિય કરો',
    customer_since: 'ગ્રાહક બન્યા:',
    total_visits: 'કુલ મુલાકાત',
    total_spent: 'કુલ ખર્ચ',
    avg_bill: 'સરેરાશ બિલ',
    last_visit: 'છેલ્લી મુલાકાત',
    days_ago: '{count} દિવસ પહેલાં',
    today: 'આજ',
    yesterday: 'ગઈ કાલ',
    no_visits_yet: 'કોઈ મુલાકાત નથી',
    customer_details: 'ગ્રાહક વિગત',
    birthday: 'જન્મદિવસ',
    gender: 'લિંગ',
    notes_label: 'નોંધ',
    not_provided: 'જણાવ્યું નથી',
    no_notes: 'કોઈ નોંધ નથી',
    visit_history_count: 'મુલાકાત ઇતિહાસ ({count})',
    bookings_count: 'બુકિંગ ({count})',
    load_more_visits: 'વધુ મુલાકાત જુઓ →',
    points_to_tier: '{tier} માટે {count} પૉઇન્ટ',
    top_customer_badge: '🏆 શ્રેષ્ઠ ગ્રાહક!',
    loyalty_points: 'લૉયલ્ટી પૉઇન્ટ',
    points_value: 'પૉઇન્ટ મૂલ્ય',
    top_services: 'શ્રેષ્ઠ સેવાઓ',
    visit_history: 'મુલાકાત ઇતિહાસ',
    this_month: 'આ મહિને',
    this_month_visits: 'આ મહિને મુલાકાત',
    this_month_spent: 'આ મહિને ખર્ચ',
    next_tier_progress: 'આગળના ટિયર સુધી',
    top_customer: 'શ્રેષ્ઠ ગ્રાહક',
    new_bill: 'નવું બિલ',
    new_booking: 'નવી બુકિંગ',
    profile_load_error: 'પ્રોફાઇલ લોડ ન થઈ. ફરી પ્રયાસ કરો.',
    profile_retry: 'ફરી પ્રયાસ',
    more_visits_message: 'વધુ મુલાકાત જોવા રિપોર્ટ્સ પર જાઓ',
    payment_cash: 'રોકડ',
    payment_card: 'કાર્ડ',
    payment_upi: 'UPI',
    loyalty_earned: 'પૉઇન્ટ મળ્યા',
    points_to_next_tier: 'આગળના ટિયર માટે પૉઇન્ટ જોઈએ',
    how_tiers_work: 'ટિયર કેવી રીતે કામ કરે છે ▼',
    how_tiers_work_close: 'ટિયર કેવી રીતે કામ કરે છે ▲',
    tier_bronze: 'બ્રોન્ઝ',
    tier_silver: 'સિલ્વર',
    tier_gold: 'ગોલ્ડ',
    tier_diamond: 'ડાયમંડ',
    tier_bronze_range: '0 – 2,000 પૉઇન્ટ',
    tier_silver_range: '2,001 – 5,000 પૉઇન્ટ',
    tier_gold_range: '5,001 – 10,000 પૉઇન્ટ',
    tier_diamond_range: '10,001+ પૉઇન્ટ',
    tier_earn_rate: 'દરેક ₹1 ખર્ચ = 1 પૉઇન્ટ',
    tier_redeem_info: 'પૉઇન્ટ વડે ડિસ્કાઉન્ટ મળી શકે',
    pts_to_next_tier: '{tier} માટે {count} પૉઇન્ટ જોઈએ',
    top_tier_achieved: '🏆 સર્વોચ્ચ ટિયર!',
    loyalty_tiers: 'લૉયલ્ટી ટિયર',
    loyalty_tiers_subtitle: 'દરેક ટિયર માટે પૉઇન્ટ મર્યાદા નક્કી કરો',
    tier_min_points: 'ન્યૂનતમ પૉઇન્ટ',
    tier_max_points: 'મહત્તમ પૉઇન્ટ',
    tier_min_auto: 'ઑટો',
    tier_preview: 'ટિયર પ્રીવ્યુ',
    tier_badges_preview: 'ટિયર બેજ પ્રીવ્યુ',
    tier_threshold_error: '{higher} ની મર્યાદા {lower} કરતાં વધારે હોવી જોઈએ',
    how_tiers_work_link: 'ℹ️ ટિયર કેવી રીતે કામ કરે છે →',
    tier_table_tier: 'ટિયર',
    svc_search: 'સેવાઓ શોધો...', svc_add: 'સેવા ઉમેરો', svc_edit: 'સેવા ફેરફાર કરો',
    svc_name: 'સેવાનું નામ', svc_category: 'શ્રેણી', svc_duration: 'સમયગાળો (મિનિટ)',
    svc_price: 'કિંમત (₹)', svc_gst: 'જીએસટી દર (%)', svc_active: 'સક્રિય', svc_inactive: 'નિષ્ક્રિય',
    svc_del_title: 'સેવા કાઢી નાખવી?', svc_del_desc: 'આ ક્રિયા પૂર્વવત કરી શકાતી નથી.',
    svc_none: 'કોઈ સેવા મળી નથી', svc_added: 'સેવા ઉમેરાઈ',
    svc_updated: 'સેવા અપડેટ થઈ', svc_deleted: 'સેવા કાઢી નખાઈ',
    svc_req: 'નામ અને કિંમત જરૂરી છે',
    staff_search: 'નામ અથવા ફોનથી શોધો...', staff_add: 'કર્મચારી ઉમેરો', staff_edit: 'કર્મચારી ફેરફાર કરો',
    staff_role: 'ભૂમિકા', staff_comm: 'કમિશન (%)',
    staff_in: 'ક્લૉક ઇન', staff_out: 'ક્લૉક આઉટ', staff_working: 'હાલમાં કામ પર',
    staff_del_title: 'કર્મચારી દૂર કરવા?', staff_del_desc: 'આ ક્રિયા પૂર્વવત કરી શકાતી નથી.',
    staff_none: 'કોઈ કર્મચારી મળ્યા નથી', staff_clocked_in: 'ક્લૉક ઇન થયા!',
    staff_clocked_out: 'ક્લૉક આઉટ થયા!', staff_added: 'કર્મચારી ઉમેરાયા',
    staff_updated: 'કર્મચારી અપડેટ થયા', staff_removed: 'કર્મચારી દૂર કરાયા',
    staff_req: 'નામ અને ફોન જરૂરી છે',
    staff_on_duty: 'ફરજ પર',
    staff_off_duty: 'ફરજ પર નથી',
    staff_total: 'કુલ સ્ટાફ',
    staff_on_duty_now: 'અત્યારે ફરજ પર',
    staff_off_duty_now: 'ફરજ પર નથી',
    staff_sub_team_members: 'ટીમ સભ્યો',
    staff_sub_currently_working: 'હાલ કામ કરી રહ્યા',
    staff_sub_not_clocked: 'ક્લૉક ઇન નથી',
    staff_stat_label_today: 'આજે',
    staff_stat_label_served: 'સેવા',
    monthly_hours_summary: 'માસિક કલાક સારાંશ',
    today_stats: 'આજના આંકડા',
    hours_worked_today: 'કલાક કામ કર્યું',
    customers_today: 'ગ્રાહક સેવા આપી',
    revenue_today: 'આજની કમાણી',
    live_timer: 'લાઇવ',
    now: 'અત્યારે',
    staff: 'સ્ટાફ',
    attendance: 'હાજરી',
    customers: 'ગ્રાહક',
    revenue: 'કમાણી',
    commission: 'કમિશન',
    clock_in: 'ક્લૉક ઇન',
    clock_out: 'ક્લૉક આઉટ',
    total: 'કુલ',
    joined: 'જોડાયા',
    visits: 'મુલાકાત',
    times: 'વાર',
    customers_served: 'સેવાયેલા ગ્રાહક',
    revenue_generated: 'કમાયેલી કમાણી',
    in_progress: 'ચાલુ છે',
    short_day: 'ઓછા કલાક',
    mon: 'સોમ', tue: 'મંગળ', wed: 'બુધ', thu: 'ગુરુ', fri: 'શુક્ર', sat: 'શનિ', sun: 'રવિ',
    this_week: 'આ અઠવાડિયે',
    revenue_last_7_days: 'કમાણી (પાછલા 7 દિવસ)',
    attendance_overview: 'હાજરી અવલોકન',
    attendance_month_year_title: 'મહિનો અને વર્ષ પસંદ કરો',
    attendance_year_label: 'વર્ષ',
    attendance_month_label: 'મહિનો',
    all_staff: 'બધો સ્ટાફ',
    full_day: 'પૂરો દિવસ',
    half_day: 'અડધો દિવસ',
    absent: 'ગેરહાજર',
    holiday: 'રજા',
    no_data: 'ડેટા નથી',
    hours_today: 'આજ',
    hours_this_week: 'આ અઠવાડિયે',
    hours_this_month: 'આ મહિને',
    avg_per_day: 'સરેરાશ/દિવસ',
    days_worked: 'દિવસ કામ કર્યા',
    full_days: 'પૂરા દિવસ',
    half_days: 'અડધા દિવસ',
    mark_holiday: 'રજા ચિહ્નિત કરો',
    mark_absent: 'ગેરહાજર ચિહ્નિત કરો',
    staff_overview: 'અવલોકન',
    staff_attendance: 'હાજરી',
    staff_performance: 'કામગીરી',
    joining_date: 'જોઇનિંગ તારીખ',
    all_time_hours: 'કુલ કલાક',
    days_present: 'હાજર દિવસ',
    days_absent: 'ગેરહાજર દિવસ',
    book_new: 'નવું બુકિંગ', book_today: 'આજે',
    book_none: 'આ દિવસે કોઈ બુકિંગ નથી', book_first: 'પહેલું બુકિંગ બનાવો',
    book_customer: 'ગ્રાહક', book_services: 'સેવાઓ',
    book_stylist: 'સ્ટાઇલિસ્ટ', book_time: 'સમય', book_notes: 'નોંધ',
    book_confirm: 'ખાતરી કરો', book_start: 'શરૂ કરો', book_complete: 'પૂર્ણ કરો',
    book_cancel: 'રદ કરો', book_del_title: 'બુકિંગ કાઢી નાખવું?',
    book_del_desc: 'આ ક્રિયા પૂર્વવત કરી શકાતી નથી.',
    book_any: 'કોઈપણ ઉપલબ્ધ', book_special: 'કોઈ ખાસ વિનંતી...',
    book_created: 'બુકિંગ બનાવ્યું', book_deleted: 'બુકિંગ કાઢી નખાયું',
    book_req: 'ગ્રાહક અને ઓછામાં ઓછી એક સેવા જરૂરી છે',
    book_search_cust: 'ગ્રાહક શોધો...', book_create: 'બુકિંગ બનાવો',
    book_new_for: 'નવું બુકિંગ -',
    booking_scheduled: 'નિર્ધારિત',
    booking_completed: 'પૂર્ણ',
    booking_cancelled: 'રદ',
    booking_no_show: 'ન આવ્યા',
    booking_complete_btn: 'પૂર્ણ કરો',
    booking_no_show_btn: 'ન આવ્યા',
    booking_cancel_btn: 'રદ કરો',
    booking_edit_btn: 'સંપાદિત કરો',
    booking_create_bill: 'બિલ બનાવો →',
    booking_past_date_warning: 'તમે જૂની તારીખ માટે બુકિંગ કરી રહ્યા છો.',
    booking_past_time_warning: 'આ સમય પસાર થઈ ગયો છે.',
    booking_cancel_confirm_title: 'બુકિંગ રદ કરો?',
    booking_cancel_confirm_body: 'આ બુકિંગ રદ થઈ જશે.',
    booking_cancel_confirm_btn: 'હા, રદ કરો',
    booking_keep_btn: 'બુકિંગ રાખો',
    booking_noshow_confirm_title: 'નો શો માર્ક કરો?',
    booking_noshow_confirm_body: '{name} એપોઇન્ટમેન્ટ પર ન આવ્યા?',
    booking_noshow_confirm_btn: 'હા, ન આવ્યા',
    booking_update_btn: 'બુકિંગ અપડેટ કરો',
    edit_booking_title: 'બુકિંગ સંપાદિત કરો',
    no_bookings_today: '{date} માટે કોઈ બુકિંગ નથી',
    no_filtered_bookings: '{date} માટે કોઈ {status} બુકિંગ નથી',
    booking_filter_all: 'બધા',
    booking_filter_scheduled: 'નિર્ધારિત',
    booking_filter_completed: 'પૂર્ણ',
    booking_filter_cancelled: 'રદ',
    booking_filter_no_show: 'ન આવ્યા',
    booking_new_customer_phone: 'ફોન (નવો ગ્રાહક)',
    booking_new_customer_phone_placeholder: '10 અંકનો ફોન નંબર',
    booking_new_customer_phone_required: 'નવો ગ્રાહક બનાવવા ફોન જરૂરી છે',
    lang_title: 'ભાષા',
    rpt_title: 'રિપોર્ટ અને વિશ્લેષણ',
    rpt_subtitle: 'તમારા સલૂનની ગ્રોથ એક જગ્યાએ ટ્રેક કરો',
    rpt_total_revenue: 'કુલ આવક',
    rpt_total_bookings: 'કુલ બુકિંગ',
    rpt_new_customers: 'નવા ગ્રાહકો',
    rpt_avg_bill_value: 'સરેરાશ બિલ',
    rpt_revenue_trend: 'આવક ટ્રેન્ડ',
    rpt_top_services: 'શ્રેષ્ઠ સેવાઓ',
    rpt_payment_methods: 'ચૂકવણી પદ્ધતિ',
    rpt_staff_performance: 'સ્ટાફ કામગીરી',
    rpt_customer_insights: 'ગ્રાહક માહિતી',
    rpt_returning_vs_new: 'પાછા ફરેલા vs નવા ગ્રાહકો',
    rpt_peak_hours: 'પીક કલાકો',
    rpt_export: 'નિકાસ',
    rpt_no_data: 'આ સમયગાળામાં કોઈ ડેટા નથી',
    rpt_today: 'આજ',
    rpt_this_week: 'આ અઠવાડિયે',
    rpt_this_month: 'આ મહિને',
    rpt_custom: 'કસ્ટમ',
    rpt_appointments: 'એપોઇન્ટમેન્ટ',
    rpt_revenue_generated: 'કમાયેલી આવક',
    rpt_commission_earned: 'કમિશન',
    rpt_top_service: 'શ્રેષ્ઠ સેવા',
    rpt_cash: 'રોકડ',
    rpt_card: 'કાર્ડ',
    rpt_upi: 'UPI',
    rpt_select_start_date: 'શરૂઆતની તારીખ',
    rpt_select_end_date: 'અંતની તારીખ',
    rpt_apply: 'લાગુ કરો',
    rpt_export_csv: 'CSV નિકાસ',
    rpt_export_pdf: 'PDF નિકાસ',
    rpt_export_excel: 'Excel નિકાસ',
    rpt_share_report: 'રિપોર્ટ શેર કરો',
    rpt_staff: 'સ્ટાફ',
    rpt_revenue: 'આવક',
    rpt_bookings: 'બુકિંગ',
    rpt_reports_load_error: 'રિપોર્ટ લોડ નથી થઈ',
    rpt_export_no_data: 'નિકાસ માટે ડેટા નથી',
    rpt_export_csv_done: 'CSV નિકાસ થઈ ગઈ',
    rpt_times_booked: 'વાર બુક થયું',
    rpt_product_usage: 'ઉત્પાદન ઉપયોગ (ખર્ચ)',
    rpt_product_name: 'ઉત્પાદન',
    rpt_quantity_used: 'જથ્થો વપરાયો',
    rpt_total_cost: 'કુલ ખર્ચ',
    rpt_returning: 'પાછા ફરેલા',
    rpt_new: 'નવા',
    rpt_summary_copied: 'સારાંશ ક્લિપબોર્ડ પર કોપી થઈ ગઈ!',
    rpt_payment: 'ચુકવણી',
    rpt_customers: 'ગ્રાહકો',
    rpt_date: 'તારીખ',
    rpt_period: 'અવધિ',
    rpt_service: 'સેવા',
    rpt_name: 'નામ',
    rpt_role: 'ભૂમિકા',
    rpt_generated_by: 'SalonSync દ્વારા જનરેટ',
    rpt_generated_on: 'જનરેટ તારીખ',
    settings: 'સેટિંગ્સ',
    settings_salon_profile: 'સલૂન પ્રોફાઇલ',
    settings_notifications: 'સૂચનાઓ',
    settings_billing: 'બિલિંગ સેટિંગ્સ',
    settings_user_mgmt: 'વપરાશકર્તા વ્યવસ્થાપન',
    settings_data_backup: 'ડેટા અને બેકઅપ',
    settings_salon_name: 'સલૂનનું નામ',
    settings_phone: 'ફોન',
    settings_email: 'ઇમેઇલ',
    settings_address: 'સરનામું',
    settings_gst: 'GST નંબર',
    settings_website: 'વેબસાઇટ',
    settings_save: 'ફેરફાર સેવ કરો',
    settings_saved: 'સેટિંગ્સ સેવ થઈ!',
    settings_inv_prefix: 'ઇન્વૉઇસ પ્રીફિક્સ',
    settings_next_inv: 'આગળનો ઇન્વૉઇસ નંબર',
    settings_loyalty_per_rupee: 'પ્રતિ ₹ લૉયલ્ટી પૉઇન્ટ',
    settings_redemption_per_point: 'પ્રતિ પૉઇન્ટ ₹ રિડેમ્પશન',
    notif_booking_title: 'બુકિંગ કન્ફર્મેશન ઓટો મોકલો',
    notif_booking_sub: 'બુકિંગ થાય ત્યારે WhatsApp મોકલો',
    notif_bill_title: 'બિલ WhatsApp પર ઓટો મોકલો',
    notif_bill_sub: 'પેમેન્ટ પછી WhatsApp પર રસીદ મોકલો',
    notif_birthday_title: 'જન્મદિવસ શુભેચ્છાઓ',
    notif_birthday_sub: 'ગ્રાહકના જન્મદિવસે ઓટો સંદેશ મોકલો',
    notif_reminder_title: 'એપોઇન્ટમેન્ટ રિમાઇન્ડર',
    notif_reminder_sub: 'એપોઇન્ટમેન્ટ પહેલાં રિમાઇન્ડર મોકલો',
    whatsapp_note: 'ઇન્ટિગ્રેશન માટે WhatsApp Business API જરૂરી છે। અત્યારે WhatsApp Web થી મેન્યુઅલી કામ કરે છે।',
    email_config: 'ઇમેઇલ કૉન્ફિગરેશન',
    resend_api_key: 'Resend API Key',
    resend_api_key_help: 'resend.com પર ફ્રી API key મેળવો',
    resend_open: 'Resend ખોલો ↗',
    resend_api_key_placeholder: 're_xxxxxxxxxxxxxxxx',
    resend_api_key_invalid: 'ખોટું ફૉર્મેટ. Key re_ થી શરૂ થવી જોઈએ',
    resend_used_for: 'ઉપયોગ: પાસવર્ડ રીસેટ, બુકિંગ, રસીદ',
    test_email: 'ટેસ્ટ ઇમેઇલ મોકલો',
    test_email_sending: 'મોકલી રહ્યા છીએ...',
    test_email_success: 'ટેસ્ટ ઇમેઇલ ગયો! ઇનબૉક્સ તપાસો.',
    test_email_failed: 'નિષ્ફળ. API key તપાસો.',
    resend_key_saved: 'ઇમેઇલ સેટિંગ્સ સેવ',
    using_system_email: 'સિસ્ટમ ડિફૉલ્ટ ઇમેઇલ વપરાઈ રહ્યો છે',
    settings_field_required: 'જરૂરી છે',
    settings_user_req: 'નામ અને ઈમેઇલ જરૂરી',
    settings_user_updated: 'યુઝર અપડેટ થયો',
    settings_user_added: 'યુઝર ઉમેરાયો',
    settings_backup_complete: 'બેકઅપ પૂર્ણ! 4 ફાઇલો ડાઉનલોડ થઈ.',
    settings_backup_failed: 'બેકઅપ નિષ્ફળ',
    settings_try_again: 'કૃપા કરીને ફરી પ્રયાસ કરો',
    settings_restore_success: 'ડેટા પુનઃસ્થાપિત થયો!',
    settings_restore_unknown: 'અજ્ઞાત ફાઇલ પ્રકાર. ગ્રાહકો, બુકિંગ્સ, સેવાઓ અથવા સ્ટાફ CSV વાપરો.',
    settings_users_demo: 'આ ફીચર હાલ ડેમો મોડમાં છે. રીયલ લોગિન સિસ્ટમ લઈને આવે છે.',
    settings_table_user: 'યુઝર',
    settings_table_role: 'ભૂમિકા',
    settings_table_status: 'સ્થિતિ',
    settings_table_actions: 'ક્રિયાઓ',
    settings_add_user: 'યુઝર ઉમેરો',
    settings_backup_full: 'સંપૂર્ણ બેકઅપ CSV માં',
    settings_restore_btn: 'બેકઅપમાંથી પુનઃસ્થાપિત કરો',
    settings_last_backup: 'છેલ્લું બેકઅપ',
    settings_never: 'ક્યારેય નહીં',
    settings_edit_user: 'યુઝર ફેરફાર કરો',
    settings_password_keep: '(રાખવા માટે ખાલી છોડો)',
    settings_update: 'અપડેટ',
    settings_add_karo: 'ઉમેરો',
    settings_restore_title: 'બેકઅપમાંથી પુનઃસ્થાપિત કરો',
    settings_restore_confirm: 'પુનઃસ્થાપનથી બધો વર્તમાન ડેટા બદલાઈ જશે. શું તમે ખાતરી કરો છો?',
    settings_restore_yes: 'હા, પુનઃસ્થાપિત કરો',
    settings_password: 'પાસવર્ડ',
    settings_status_active: 'સક્રિય',
    settings_status_inactive: 'નિષ્ક્રિય',
    settings_you_badge: 'તમે',
    settings_password_optional_hint: 'પાસવર્ડ બદલવું નથી? ખાલી છોડો',
    settings_confirm_password: 'પાસવર્ડ ખાતરી કરો',
    settings_deactivate_confirm: 'આ યુઝરને ડિએક્ટિવેટ કરો?',
    settings_deactivate: 'ડિએક્ટિવેટ',
    settings_users_load_error: 'યુઝર લોડ નથી થયા',
    inv_total_products: 'કુલ ઉત્પાદો',
    inv_low_stock: 'ઓછો સ્ટૉક',
    inv_inventory_value: 'ઇન્વેન્ટરી મૂલ્ય',
    inv_product_add: 'ઉત્પાદ ઉમેરો',
    inv_product_search: 'ઉત્પાદ શોધો...',
    inv_filter_all: 'બધા',
    inv_filter_low_stock: 'ઓછો સ્ટૉક',
    inv_filter_out_of_stock: 'સ્ટૉક ખતમ',
    inv_min_threshold: 'લઘુત્તમ મર્યાદા',
    inv_cost_price: 'ખર્ચ કિંમત',
    inv_brand: 'બ્રાન્ડ',
    inv_stock_history: 'સ્ટૉક ઇતિહાસ',
    inv_stock_add: 'સ્ટૉક વધારો',
    inv_stock_reduce: 'સ્ટૉક ઘટાડો',
    inv_update_karo: 'અપડેટ કરો',
    inv_reason_new_stock: 'નવો સ્ટૉક',
    inv_reason_return: 'પરત',
    inv_reason_correction: 'સુધારો',
    inv_reason_used: 'સેવામાં વપરાશ',
    inv_reason_damaged: 'નુકસાન',
    inv_reason_expired: 'એક્સપાયર',
    inv_products_low_stock: 'ઉત્પાદો ઓછા સ્ટૉકમાં છે',
    inv_whatsapp_alert: 'WhatsApp એલર્ટ મોકલો',
    inv_low_stock_alert: 'ઓછો સ્ટૉક એલર્ટ',
    inv_restock_karo: 'રિસ્ટૉક કરો',
    inv_stock_updated: 'સ્ટૉક અપડેટ થઈ ગયો!',
    inv_dismiss: 'બંધ કરો',
    inv_clear_history: 'ઇતિહાસ સાફ કરો',
    inv_low_stock_in: 'ઓછા સ્ટૉકમાં છે',
    inv_save_karo: 'સાચવો',
    inv_min_alert_helper: 'આથી ઓછું થતાં અલર્ટ મળશે',
    inv_current_stock: 'વર્તમાન સ્ટૉક',
    inv_product_name: 'ઉત્પાદનું નામ',
    inv_category: 'શ્રેણી',
    inv_unit: 'એકમ',
    inv_type: 'પ્રકાર',
    inv_quantity: 'માત્રા',
    inv_reason: 'કારણ',
    inv_time: 'સમય',
    inv_clear_confirm: 'ઇતિહાસ સાફ કરો?',
    inv_del_title: 'ઉત્પાદ કાઢી નાખવું?',
    inv_del_desc: 'આ ક્રિયા પૂર્વવત કરી શકાતી નથી.',
    inv_none: 'કોઈ ઉત્પાદ મળ્યું નથી',
    inv_add_stock: '+ સ્ટૉક ઉમેરો',
    inv_stock_btn: 'સ્ટૉક',
    inv_product: 'ઉત્પાદ',
    use_tracking: 'ઉપયોગ-આધારિત ટ્રૅકિંગ',
    use_per_unit: 'પ્રતિ {unit} ઉપયોગ',
    use_name: 'ઉપયોગનું નામ',
    use_stroke: 'સ્ટ્રોક',
    use_pump: 'પંપ',
    use_spray: 'સ્પ્રે',
    use_scoop: 'સ્કૂપ',
    use_available: 'સ્ટ્રોક ઉપલબ્ધ',
    use_alert_below: 'એલર્ટ મર્યાદા (ઉપયોગ)',
    use_bottles_added: 'બોટલ ઉમેરી = {x} સ્ટ્રોક ઉમેર્યા',
    use_one_call: 'એક ઉપયોગને શું કહેશો?',
    use_stock_label: 'ઉપયોગ-આધારિત સ્ટૉક',
    use_per_use: 'પ્રતિ ઉપયોગ',
    use_modal_helper: 'કન્ટેનરમાં કેટલા ઉપયોગ?',
    use_alert_helper: 'કેટલા ઉપયોગ બાકી ત્યારે એલર્ટ?',
    use_status: '{x} {useUnit} ઉપલબ્ધ, {y} {unit} માં',
    use_kitni_units: 'કેટલી {units} ઉમેરી?',
    use_kitne_use: 'કેટલા {useUnit} ઉપયોગ થયા?',
    use_added_msg: '{units} ઉમેરી = {x} {useUnit} ઉમેર્યા',
    val_name_min: 'At least 2 characters required',
    val_name_max: 'Maximum 100 characters',
    val_stock_min: 'Must be 0 or more',
    val_stock_number: 'Must be a number',
    val_uses_required: 'Required when use-based tracking is on',
    val_uses_min: 'At least 1 required',
    val_phone_10: 'Exactly 10 digits required',
    val_phone_numbers: 'Numbers only',
    val_email_invalid: 'Enter a valid email or leave empty',
    val_customer_or_walkin: 'Select a customer or continue as walk-in',
    val_services_one: 'Select at least one service',
    val_date_past: 'Date/time is in the past',
    val_payment_method: 'Select payment method',
    del_confirm_title: 'Delete karna chahte hain?',
    del_confirm_desc: 'Ye action undo nahi ho sakta.',
    del_confirm_btn: 'Haan, Delete Karo',
    del_cancel: 'Cancel',
    notifications: 'સૂચનાઓ',
    mark_all_read: 'બધા વાંચ્યા ચિહ્નિત કરો',
    no_notifications: 'કોઈ સૂચના નથી',
    low_stock_notif: 'ઓછો સ્ટૉક',
    new_booking_notif: 'નવી બુકિંગ',
    payment_notif: 'ચૂકવણી',
    system_notif: 'સિસ્ટમ',
    my_profile: 'મારી પ્રોફાઇલ',
    change_password: 'પાસવર્ડ બદલો',
    current_password: 'વર્તમાન પાસવર્ડ',
    new_password: 'નવો પાસવર્ડ',
    confirm_new_password: 'પાસવર્ડ કન્ફર્મ કરો',
    password_changed: 'પાસવર્ડ બદલાઈ ગયો',
    logout_confirm: 'લૉગઆઉટ કરવા માગો છો?',
    logout_confirm_title: 'લૉગઆઉટ કરો?',
    just_now: 'હમણાં',
    min_ago: 'મિનિટ પહેલાં',
    hour_ago: 'એક કલાક પહેલાં',
    hours_ago: 'કલાક પહેલાં',
    view_inventory: 'ઇન્વેન્ટરી જુઓ',
    view_bookings: 'બુકિંગ જુઓ',
    older_notifications: 'જૂની સૂચનાઓ',
    notif_select: 'પસંદ કરો',
    notif_selected: 'selected',
    notif_delete_selected: 'પસંદ કરેલ ડિલીટ કરો',
    notif_delete_all: 'બધા ડિલીટ',
    notif_delete_all_confirm_title: 'બધી સૂચનાઓ ડિલીટ કરો?',
    notif_delete_all_confirm_body: 'આ પૂર્વવત્ થઈ શકશે નહીં।',
    notif_delete_all_confirm_btn: 'હા, બધા કાઢો',
    notif_deleted: 'સૂચના ડિલીટ થઈ',
    notif_deleted_count: '{count} સૂચનાઓ ડિલીટ થઈ',
    notif_delete_single_confirm: 'આ સૂચના ડિલીટ કરો?',
    payment_received: 'ચૂકવણી મળી',
    new_customer_added: 'નવો ગ્રાહક ઉમેર્યો',
    new_staff_added: 'નવો સ્ટાફ ઉમેર્યો',
    staff_clock_in_notif: 'સ્ટાફે કામ શરૂ કર્યું',
    staff_clock_out_notif: 'સ્ટાફે કામ પૂર્ણ કર્યું',
    new_product_added: 'નવી પ્રોડક્ટ ઉમેરી',
    stock_updated: 'સ્ટૉક અપડેટ થયો',
    new_service_added: 'નવી સેવા ઉમેરી',
    settings_updated_notif: 'સેટિંગ્સ અપડેટ થઈ',
    select_cancel: 'રદ કરો',
    hours_worked: 'કલાક કામ કર્યું',
    notif_low_stock_title: 'ઓછો સ્ટૉક એલર્ટ',
    notif_low_stock_message: '{product} નો સ્ટૉક ઓછો થઈ રહ્યો છે',
    notif_payment_title: 'ચૂકવણી મળી',
    notif_payment_message: '{customer} - ₹{amount} {method} દ્વારા',
    notif_walkin_payment_message: 'વૉક-ઇન - ₹{amount} {method} દ્વારા',
    notif_new_customer_title: 'નવો ગ્રાહક ઉમેર્યો',
    notif_new_customer_message: '{name} નું એકાઉન્ટ બન્યું',
    notif_new_staff_title: 'નવો સ્ટાફ ઉમેર્યો',
    notif_new_staff_message: '{name} ({role}) ને ઉમેર્યા',
    notif_clock_in_title: 'સ્ટાફ કામ શરૂ',
    notif_clock_in_message: '{name} એ આજે કામ શરૂ કર્યું',
    notif_clock_out_title: 'સ્ટાફ કામ પૂર્ણ',
    notif_clock_out_message: '{name} એ આજે {hours} કલાક કામ કર્યું',
    notif_new_product_title: 'નવી પ્રોડક્ટ ઉમેરી',
    notif_new_product_message: '{name} ઇન્વેન્ટરીમાં ઉમેરાઈ',
    notif_stock_updated_title: 'સ્ટૉક અપડેટ થયો',
    notif_stock_updated_message: '{name} માં {quantity} {unit} ઉમેર્યા',
    notif_new_service_title: 'નવી સેવા ઉમેરી',
    notif_new_service_message: '{name} - ₹{price} ઉમેરી',
    notif_new_booking_title: 'નવી બુકિંગ',
    notif_new_booking_message: '{customer} ની બુકિંગ {time} પર',
    notif_settings_title: 'સેટિંગ્સ અપડેટ થઈ',
    notif_settings_message: 'સલૂન પ્રોફાઇલ અપડેટ થઈ',
    notif_welcome_title: 'SalonSync માં આપનું સ્વાગત છે!',
    notif_welcome_message: 'સેટઅપ પૂર્ણ. સેવાઓ, સ્ટાફ ઉમેરો અને બિલિંગ શરૂ કરો!',
    loading: 'લોડ થઈ રહ્યું છે...',
    delete_failed: 'ડિલીટ ફેલ',
    password_mismatch: 'પાસવર્ડ મેળ ખાતા નથી',
    password_required: 'વર્તમાન પાસવર્ડ જરૂરી',
    password_update_failed: 'પાસવર્ડ અપડેટ ફેલ',
    dash_load_error: 'ડેશબોર્ડ ડેટા લોડ નથી થયો',
    book_load_error: 'બુકિંગ લોડ નથી થઈ',
    book_create_error: 'બુકિંગ બનાવવામાં નિષ્ફળ',
    book_status_error: 'સ્ટેટસ અપડેટ નિષ્ફળ',
    update_failed: 'અપડેટ ન થયું',
    book_delete_error: 'ડિલીટ નિષ્ફળ',
    book_whatsapp_confirm: 'શું તમે WhatsApp દ્વારા કન્ફર્મેશન મોકલવા માંગો છો?',
    book_status_updated: 'બુકિંગ {status}',
    book_whatsapp_coming_soon: 'WhatsApp રિમાઇન્ડર: લઈને આવે છે!',
    settings_load_error: 'સેટિંગ્સ લોડ નથી થઈ',
    settings_save_error: 'સેવ નિષ્ફળ',
    cust_load_error: 'ગ્રાહકો લોડ નથી થયા',
    cust_save_error: 'ગ્રાહક સેવ નિષ્ફળ',
    cust_edit_load_error: 'ફેરફાર માટે ગ્રાહક લોડ નથી થયો',
    cust_deactivate_error: 'નિષ્ક્રિય કરવામાં નિષ્ફળ',
    cust_reactivate_error: 'ફરી સક્રિય કરવામાં નિષ્ફળ',
    bill_payment_failed: 'ચુકવણી નિષ્ફળ. કૃપા કરીને ફરી પ્રયાસ કરો.',
    bill_receipt_downloaded: 'રસીદ PDF ડાઉનલોડ થઈ',
    bill_whatsapp_coming_soon: 'WhatsApp ઇન્ટિગ્રેશન લઈને આવે છે!',
    svc_load_error: 'સેવાઓ લોડ નથી થઈ',
    svc_save_error: 'સેવા સેવ નિષ્ફળ',
    svc_delete_error: 'સેવા કાઢવામાં નિષ્ફળ',
    staff_load_error: 'સ્ટાફ લોડ નથી થયા',
    staff_save_error: 'સ્ટાફ સેવ નિષ્ફળ',
    staff_clock_in_error: 'ક્લૉક ઇન નિષ્ફળ',
    staff_clock_out_error: 'ક્લૉક આઉટ નિષ્ફળ',
    staff_delete_error: 'સ્ટાફ કાઢવામાં નિષ્ફળ',
    app_access: 'ઍપ ઍક્સેસ',
    give_app_access: 'SalonSync ઍપ ઍક્સેસ આપો',
    app_access_enabled: 'ઍપ ઍક્સેસ ચાલુ છે',
    app_access_disabled: 'ઍપ ઍક્સેસ નથી',
    app_access_card_active: 'સક્રિય',
    app_access_card_off: 'ચાલુ નથી',
    app_access_no_access: 'ઍક્સેસ નથી',
    app_access_active_line: 'સક્રિય — {email}',
    app_access_optional_section: 'ઍપ ઍક્સેસ (વૈકલ્પિક)',
    app_access_cannot_login: 'સ્ટાફ સભ્ય SalonSync માં લૉગિન કરી શકશે નહીં.',
    app_access_login_blurb: 'તેઓ આ ક્રેડેન્શિયલ્સથી લૉગિન કરશે. ભૂમિકા: {role} — {access}',
    enable_login: 'લૉગિન ચાલુ કરો',
    disable_login: 'ઍક્સેસ દૂર કરો',
    change_password: 'પાસવર્ડ બદલો',
    login_email: 'લૉગિન ઇમેઇલ',
    login_password: 'લૉગિન પાસવર્ડ',
    login_password_placeholder: 'ઓછામાં ઓછા 8 અક્ષર',
    staff_app_access_title: 'સ્ટાફ ઍપ ઍક્સેસ',
    staff_app_access_subtitle: 'કોણ લૉગિન કરી શકે અને શું જોઈ શકે તે મેનેજ કરો',
    add_staff_member: 'સ્ટાફ ઉમેરો',
    staff_table_member: 'સ્ટાફ સભ્ય',
    staff_has_app_access_email: 'ઍપ ઍક્સેસ છે ({email})',
    remove_app_access_confirm: 'તેઓ હવે સાઇન ઇન કરી શકશે નહીં. પછીથી ફરી ઍક્સેસ ચાલુ કરી શકાય છે.',
    role_access_owner: 'સંપૂર્ણ ઍક્સેસ',
    role_access_manager: 'સેટિંગ્સ સિવાય બધું',
    role_access_receptionist: 'બુકિંગ, બિલિંગ, ગ્રાહકો',
    role_access_stylist: 'ફક્ત બુકિંગ',
    auth_failed: 'પ્રમાણીકરણ નિષ્ફળ',
    demo_loaded: 'ડેમો ડેટા લોડ! owner@salonsync.com / admin123 થી લોગિન કરો',
    demo_load_error: 'ડેમો ડેટા લોડ નિષ્ફળ',
    login_welcome_toast: 'સ્વાગત છે, {name}!',
    login_welcome_back_toast: 'ફરી સ્વાગત છે, {name}!',
  },
  hinglish: {
    nav_dashboard: 'Dashboard', nav_bookings: 'Bookings', nav_billing: 'Billing / POS',
    nav_customers: 'Customers', nav_services: 'Services', nav_staff: 'Staff', nav_inventory: 'Inventory', nav_reports: 'Reports', nav_logout: 'Logout',
    search: 'Dhundho', save: 'Save Karo', saving: 'Save ho raha hai...', cancel: 'Cancel Karo', delete: 'Hata Do',
    remove: 'Hatao', edit: 'Edit Karo', add: 'Add Karo', confirm: 'Confirm Karo', close: 'Band Karo',
    name: 'Naam', phone: 'Phone', email: 'Email', notes: 'Notes',
    login_welcome: 'Wapas Aao', login_subtitle: 'Apna salon manage karo',
    login_create: 'Account Banao', login_create_sub: 'Minutes mein salon setup karo',
    login_your_name: 'Tumhara Naam', login_salon_name: 'Salon ka Naam',
    login_sign_in: 'Sign In Karo', login_sign_up: 'Account Banao',
    login_no_account: 'Account nahi hai? Sign Up Karo',
    login_have_account: 'Account hai? Sign In Karo',
    auth_session_expired: 'Session expire ho gayi. Dobara login karein.',
    errb_title: 'Kuch gadbad ho gayi',
    errb_subtitle: 'Something went wrong',
    errb_retry: 'Dobara Try Karein',
    errb_logged: 'Error has been logged.',
    offline_banner: 'Internet nahi hai — changes save nahi honge',
    offline_toast_restored: '✅ Internet wapas aa gaya!',
    login_load_demo: 'Demo Data Load Karo', login_demo_desc: 'Sample services, staff aur customers setup karo',
    login_tagline: 'Tumhara Complete Salon\nManagement Solution',
    login_tagline_desc: 'Booking, billing, staff, aur customers — sab ek app mein.',
    login_enter_name: 'Apna naam dalo', login_enter_email: 'you@example.com',
    login_enter_pass: 'Password dalo', login_enter_salon: 'jaise: Glamour Studio',
    email: 'Email', password: 'Password', your_name: 'Aapka Naam', salon_name: 'Salon ka Naam',
    confirm_password: 'Password Confirm Karo', sign_in: 'Sign In Karo', create_account: 'Account Banao',
    signing_in: 'Sign in ho raha hai...', creating_account: 'Account ban raha hai...',
    invalid_credentials: 'Galat email ya password', already_have_account: 'Pehle se account hai?',
    dont_have_account: 'Account nahi hai?', sign_up: 'Sign Up Karo', sign_in_link: 'Sign In Karo',
    welcome_back: 'Wapas Aaye! Swagat Hai', sign_in_subtitle: 'Apna salon manage karo',
    create_account_subtitle: 'Minutes mein setup karo', forgot_password: 'Password bhool gaye?',
    password_strength: 'Password ki Strength', strength_weak: 'Weak', strength_fair: 'Theek Hai', strength_good: 'Accha', strength_strong: 'Strong',
    val_email_required: 'Email daalna zaroori hai', val_email_invalid: 'Sahi email daalo',
    val_password_required: 'Password daalna zaroori hai', val_password_min: 'Password kam se kam 8 characters ka ho', val_password_min_login: 'Password kam se kam 6 characters ka ho',
    val_name_required: 'Naam daalna zaroori hai', val_name_min: 'Naam kam se kam 2 characters ka ho',
    val_salon_required: 'Salon ka naam daalna zaroori hai', val_passwords_match: 'Dono passwords match nahi karte',
    forgot_title: 'Password bhool gaye?',
    forgot_body: 'Apne SalonSync admin se password reset karwao.',
    forgot_hint: 'Admin Settings → User Management se password badal sakta hai',
    back_to_login: '← Login pe wapas',
    dash_morning: 'Good Morning', dash_afternoon: 'Good Afternoon', dash_evening: 'Good Evening',
    dash_today_rev: 'Aaj ki Revenue', dash_today_book: 'Aaj ki Bookings',
    dash_new_cust: 'Is mahine Naye Customers', dash_top_svc: 'Aaj Top Service',
    dash_pending: 'pending', dash_this_month: 'Is mahine',
    dash_new_booking: 'Booking Karo', dash_new_bill: 'Bill Banao', dash_add_cust: 'Customer Add Karo',
    dash_rev_7: 'Revenue (Pichle 7 Din)', dash_svc_cat: 'Service Categories',
    dash_upcoming: 'Aane wale Appointments', dash_view_all: 'Sab Dekho',
    dash_no_billing: 'Abhi tak koi bill nahi. Pehla bill banao!',
    dash_no_upcoming: 'Koi aane wali appointment nahi', dash_revenue: 'Revenue',
    access_restricted: 'Access Nahi Hai',
    access_restricted_body: 'Aapka role ({role}) is page ko dekhne ki permission nahi deta.',
    access_stylist_hint: 'Aap dekh sakte hain: Dashboard aur Bookings',
    access_receptionist_hint: 'Aap dekh sakte hain: Dashboard, Bookings, Billing aur Customers',
    access_manager_hint: 'Settings chhodke sab kuch',
    go_to_dashboard: '← Dashboard pe jao',
    my_schedule_today: 'Aaj Mera Schedule',
    no_bookings_today_stylist: 'Aaj aapke liye koi booking nahi',
    bill_search: 'Service dhundho...', bill_items: 'Bill Items', bill_customer: 'Customer',
    bill_pricing: 'Price Summary', bill_pay_method: 'Payment Kaise',
    bill_mark_paid: 'Paid Mark Karo', bill_processing: 'Process ho raha hai...',
    bill_subtotal: 'Subtotal', bill_discount: 'Discount',
    bill_cgst: 'CGST (9%)', bill_sgst: 'SGST (9%)', bill_total: 'Total',
    bill_cash: 'Cash', bill_card: 'Card', bill_upi: 'UPI', bill_split: 'Split',
    bill_search_cust: 'Naam ya phone se customer dhundho...',
    bill_walkin: 'ya Walk-in continue karo', bill_remove_cust: 'Customer Hatao',
    no_customer_found: '"{query}" ke liye koi customer nahi mila',
    create_new_customer: '+ Naya Customer Banao',
    new_customer_title: 'Naya Customer',
    new_customer_save: 'Save & Continue',
    new_customer_created: '✓ Naya customer create ho gaya',
    bill_success: 'Payment Ho Gaya!', bill_download: 'Receipt Download Karo (PDF)',
    bill_whatsapp: 'WhatsApp se Bhejo', bill_new: 'Naya Bill',
    bill_loyalty: 'loyalty points', bill_estimated: 'Anumaan',
    bill_add_items: 'Pehle bill mein item add karo', bill_complete: 'Payment ho gaya!',
    bill_added: 'Add ho gaya',
    bill_products_used: 'Products Used (Optional)',
    bill_product_search: 'Product dhundho...',
    bill_products_added: 'products added',
    bill_available: 'Available',
    bill_internal_cost: 'Internal Product Cost',
    bill_ab_low_stock: 'ab low stock mein hai!',
    bill_out_of_stock: 'OUT OF STOCK ho gaya!',
    bill_products_select: 'Select Products',
    bill_product_search_modal: 'Search by name...',
    bill_available_lower: 'available',
    bill_out_of_stock_label: 'Out of Stock',
    bill_products_selected: 'products selected',
    bill_confirm_add: 'Confirm Add',
    bill_add_more: '+ Add More',
    bill_product_cost_internal: 'Product Cost (Internal)',
    served_by: 'Kisne Serve Kiya',
    select_staff: 'Staff chunein...',
    not_specified: 'Bataya nahi',
    served_by_optional: 'Optional — walk-ins ke liye skip kar sakte hain',
    bill_recent_bills: 'Recent Bills',
    staff_performance_bills: 'bills se',
    staff_performance_bookings: 'bookings',
    low_stock_toast: '⚠️ {product} ab low stock mein hai! Restock karo.',
    out_of_stock_toast: '🚨 {product} OUT OF STOCK ho gaya!',
    stock_deducted: '{product} ka stock update ho gaya',
    cust_search: 'Naam ya phone se dhundho...', cust_add: 'Customer Add Karo',
    cust_edit: 'Customer Edit Karo', cust_profile: 'Customer Profile',
    cust_visits: 'visits', cust_total: 'Total Kharch', cust_points: 'Points',
    cust_none: 'Koi customer nahi mila', cust_history: 'Visit History',
    cust_bookings: 'Bookings', view_bookings: 'Sab bookings dekho',
    cust_no_history: 'Abhi tak koi billing history nahi',
    cust_req: 'Naam aur phone zaroori hai', cust_added: 'Customer add ho gaya',
    cust_updated: 'Customer update ho gaya', cust_birthday: 'Birthday', cust_gender: 'Gender',
    cust_prefs: 'Pasand, allergy, etc.',
    customer_deactivate: 'Deactivate Karo',
    customer_deactivate_confirm_title: 'Customer ko deactivate karein?',
    customer_deactivate_confirm_body: 'Ye customer active list se hata diya jayega. Unka data safe rahega.',
    customer_deactivated_toast: 'Customer deactivate ho gaya',
    customer_reactivate: 'Wapas Active Karo',
    customer_reactivated_toast: 'Customer wapas active ho gaya',
    show_inactive_customers: 'Inactive customers bhi dikhao',
    customer_inactive_badge: 'Inactive',
    customer_deactivate_confirm_btn: 'Haan, Deactivate Karo',
    customer_since: 'Grahak bane:',
    total_visits: 'Kul Visits',
    total_spent: 'Kul Spend',
    avg_bill: 'Avg Bill',
    last_visit: 'Aakhri Visit',
    days_ago: '{count} din pehle',
    today: 'Aaj',
    yesterday: 'Kal',
    no_visits_yet: 'Koi visit nahi',
    customer_details: 'Customer Details',
    birthday: 'Birthday',
    gender: 'Gender',
    notes_label: 'Notes',
    not_provided: 'Bataya nahi',
    no_notes: 'Koi notes nahi',
    visit_history_count: 'Visit History ({count})',
    bookings_count: 'Bookings ({count})',
    load_more_visits: 'Aur Visits Dekho →',
    points_to_tier: '{tier} ke liye {count} points',
    top_customer_badge: '🏆 Top Customer!',
    loyalty_points: 'Loyalty Points',
    points_value: 'Points ki Value',
    top_services: 'Top Services',
    visit_history: 'Visit History',
    this_month: 'Is Mahine',
    this_month_visits: 'Is mahine visits',
    this_month_spent: 'Is mahine spend',
    next_tier_progress: 'Agle tier tak',
    top_customer: 'Top Customer!',
    new_bill: 'Naya Bill',
    new_booking: 'Nayi Booking',
    profile_load_error: 'Profile load nahi hua. Dobara try karo.',
    profile_retry: 'Dobara try karo',
    more_visits_message: 'Aur visits dekhein Reports jaiye',
    payment_cash: 'Cash',
    payment_card: 'Card',
    payment_upi: 'UPI',
    loyalty_earned: 'Points mile',
    points_to_next_tier: 'Agle tier ke liye points chahiye',
    how_tiers_work: 'Tiers kaise kaam karte hain ▼',
    how_tiers_work_close: 'Tiers kaise kaam karte hain ▲',
    tier_bronze: 'Bronze',
    tier_silver: 'Silver',
    tier_gold: 'Gold',
    tier_diamond: 'Diamond',
    tier_bronze_range: '0 – 2,000 pts',
    tier_silver_range: '2,001 – 5,000 pts',
    tier_gold_range: '5,001 – 10,000 pts',
    tier_diamond_range: '10,001+ pts',
    tier_earn_rate: 'Har ₹1 kharch = 1 point',
    tier_redeem_info: 'Points se discount mil sakta hai',
    pts_to_next_tier: '{tier} ke liye {count} points chahiye',
    top_tier_achieved: '🏆 Sabse upar ka tier!',
    loyalty_tiers: 'Loyalty Tiers',
    loyalty_tiers_subtitle: 'Har tier ke liye point limit set karo',
    tier_min_points: 'Min Points',
    tier_max_points: 'Max Points',
    tier_min_auto: 'auto',
    tier_preview: 'Tier Preview',
    tier_badges_preview: 'Tier Badges Preview',
    tier_threshold_error: '{higher} ki limit {lower} se zyada honi chahiye',
    how_tiers_work_link: 'ℹ️ Tiers kaise kaam karte hain →',
    tier_table_tier: 'Tier',
    svc_search: 'Service dhundho...', svc_add: 'Service Add Karo', svc_edit: 'Service Edit Karo',
    svc_name: 'Service ka Naam', svc_category: 'Category', svc_duration: 'Kitni Der (mins)',
    svc_price: 'Price (₹)', svc_gst: 'GST Rate (%)', svc_active: 'Active', svc_inactive: 'Inactive',
    svc_del_title: 'Service Hata Do?', svc_del_desc: 'Ye wapas nahi aa sakta.',
    svc_none: 'Koi service nahi mili', svc_added: 'Service add ho gayi',
    svc_updated: 'Service update ho gayi', svc_deleted: 'Service hata di',
    svc_req: 'Naam aur price zaroori hai',
    staff_search: 'Naam ya phone se dhundho...', staff_add: 'Staff Add Karo', staff_edit: 'Staff Edit Karo',
    staff_role: 'Role', staff_comm: 'Commission (%)',
    staff_in: 'Clock In', staff_out: 'Clock Out', staff_working: 'Abhi Kaam pe',
    staff_del_title: 'Staff Member Hatao?', staff_del_desc: 'Ye wapas nahi aa sakta.',
    staff_none: 'Koi staff nahi mila', staff_clocked_in: 'Clock in ho gaya!',
    staff_clocked_out: 'Clock out ho gaya!', staff_added: 'Staff add ho gaya',
    staff_updated: 'Staff update ho gaya', staff_removed: 'Staff hata diya',
    staff_req: 'Naam aur phone zaroori hai',
    staff_on_duty: 'Kaam pe hai',
    staff_off_duty: 'Kaam pe nahi',
    staff_total: 'Total Staff',
    staff_on_duty_now: 'Abhi kaam pe',
    staff_off_duty_now: 'Kaam pe nahi',
    staff_sub_team_members: 'team members',
    staff_sub_currently_working: 'abhi kaam kar rahe',
    staff_sub_not_clocked: 'clock in nahi',
    staff_stat_label_today: 'Aaj',
    staff_stat_label_served: 'Served',
    monthly_hours_summary: 'Mahine ke ghante',
    today_stats: 'Aaj ke stats',
    hours_worked_today: 'ghante kaam kiya',
    customers_today: 'customers serve kiye',
    revenue_today: 'aaj ki kamai',
    live_timer: 'Live',
    attendance_overview: 'Attendance Overview',
    attendance_month_year_title: 'Mahina aur saal chuno',
    attendance_year_label: 'Saal',
    attendance_month_label: 'Mahina',
    all_staff: 'Sab Staff',
    full_day: 'Poora Din',
    half_day: 'Aadha Din',
    absent: 'Absent',
    holiday: 'Chutti',
    no_data: 'Data nahi',
    hours_today: 'Aaj',
    hours_this_week: 'Is Hafte',
    hours_this_month: 'Is Mahine',
    avg_per_day: 'Avg/din',
    days_worked: 'Din kaam kiye',
    full_days: 'Poore din',
    half_days: 'Aadhe din',
    mark_holiday: 'Chutti mark karo',
    mark_absent: 'Absent mark karo',
    staff_overview: 'Overview',
    staff_attendance: 'Attendance',
    staff_performance: 'Performance',
    joining_date: 'Joining Date',
    all_time_hours: 'Kul Ghante',
    days_present: 'Present Din',
    days_absent: 'Absent Din',
    book_new: 'Naya Booking', book_today: 'Aaj',
    book_none: 'Is din koi booking nahi', book_first: 'Pehla Booking Banao',
    book_customer: 'Customer', book_services: 'Services',
    book_stylist: 'Stylist', book_time: 'Time', book_notes: 'Notes',
    book_confirm: 'Confirm Karo', book_start: 'Shuru Karo', book_complete: 'Complete Karo',
    book_cancel: 'Cancel Karo', book_del_title: 'Booking Hata Do?',
    book_del_desc: 'Ye wapas nahi aa sakta.',
    book_any: 'Koi bhi available', book_special: 'Koi special request...',
    book_created: 'Booking ban gayi', book_deleted: 'Booking hata di',
    book_req: 'Customer aur kam se kam ek service zaroori hai',
    book_search_cust: 'Customer dhundho...', book_create: 'Booking Banao',
    book_new_for: 'Naya Booking -',
    booking_scheduled: 'Scheduled',
    booking_completed: 'Complete Ho Gaya',
    booking_cancelled: 'Cancel Ho Gaya',
    booking_no_show: 'Nahi Aaya',
    booking_complete_btn: 'Complete Karo',
    booking_no_show_btn: 'Nahi Aaya',
    booking_cancel_btn: 'Cancel Karo',
    booking_edit_btn: 'Edit Karo',
    booking_create_bill: 'Bill Banao →',
    booking_past_date_warning: 'Aap purani date ke liye booking kar rahe hain.',
    booking_past_time_warning: 'Ye time nikal gaya hai.',
    booking_cancel_confirm_title: 'Booking cancel karein?',
    booking_cancel_confirm_body: 'Ye booking cancel ho jayegi.',
    booking_cancel_confirm_btn: 'Haan, Cancel Karo',
    booking_keep_btn: 'Booking Rakho',
    booking_noshow_confirm_title: 'No Show mark karein?',
    booking_noshow_confirm_body: '{name} appointment pe nahi aaya?',
    booking_noshow_confirm_btn: 'Haan, Nahi Aaya',
    booking_update_btn: 'Booking Update Karo',
    edit_booking_title: 'Booking Edit Karo',
    no_bookings_today: '{date} ke liye koi booking nahi',
    no_filtered_bookings: '{date} ke liye koi {status} booking nahi',
    booking_filter_all: 'All',
    booking_filter_scheduled: 'Scheduled',
    booking_filter_completed: 'Complete',
    booking_filter_cancelled: 'Cancel',
    booking_filter_no_show: 'Nahi Aaya',
    booking_new_customer_phone: 'Phone (naya customer)',
    booking_new_customer_phone_placeholder: '10-digit phone number',
    booking_new_customer_phone_required: 'Naya customer banane ke liye phone zaroori hai',
    lang_title: 'LANGUAGE',
    rpt_title: 'Reports & Analytics',
    rpt_subtitle: 'Salon ki growth ko ek jagah se track karo',
    rpt_total_revenue: 'Kul Revenue',
    rpt_total_bookings: 'Kul Bookings',
    rpt_new_customers: 'Naye Customers',
    rpt_avg_bill_value: 'Avg Bill Value',
    rpt_revenue_trend: 'Revenue Trend',
    rpt_top_services: 'Top Services',
    rpt_payment_methods: 'Payment Methods',
    rpt_staff_performance: 'Staff Performance',
    rpt_customer_insights: 'Customer Insights',
    rpt_returning_vs_new: 'Returning vs Naye Customers',
    rpt_peak_hours: 'Peak Hours',
    rpt_export: 'Export',
    rpt_no_data: 'Is period mein koi data nahi hai',
    rpt_today: 'Today',
    rpt_this_week: 'This Week',
    rpt_this_month: 'This Month',
    rpt_custom: 'Custom',
    rpt_appointments: 'Appointments',
    rpt_revenue_generated: 'Revenue Generated',
    rpt_commission_earned: 'Commission Earned',
    rpt_top_service: 'Top Service',
    rpt_cash: 'Cash',
    rpt_card: 'Card',
    rpt_upi: 'UPI',
    rpt_select_start_date: 'Select Start Date',
    rpt_select_end_date: 'Select End Date',
    rpt_apply: 'Apply',
    rpt_export_csv: 'Export as CSV',
    rpt_export_pdf: 'Export as PDF',
    rpt_export_excel: 'Export as Excel',
    rpt_share_report: 'Share Report',
    rpt_staff: 'Staff',
    rpt_revenue: 'Revenue',
    rpt_bookings: 'Bookings',
    rpt_reports_load_error: 'Reports load nahi hua',
    rpt_export_no_data: 'Export ke liye data nahi mila',
    rpt_export_csv_done: 'CSV export ho gaya',
    rpt_times_booked: 'baar book hua',
    rpt_product_usage: 'Product usage (cost)',
    rpt_product_name: 'Product',
    rpt_quantity_used: 'Qty used',
    rpt_total_cost: 'Total cost',
    rpt_returning: 'Returning',
    rpt_new: 'Naye',
    rpt_summary_copied: 'Summary copied to clipboard!',
    rpt_payment: 'Payment',
    rpt_customers: 'Customers',
    rpt_date: 'Date',
    rpt_period: 'Period',
    rpt_service: 'Service',
    rpt_name: 'Name',
    rpt_role: 'Role',
    rpt_generated_by: 'Generated by SalonSync',
    rpt_generated_on: 'Generated on',
    settings: 'Settings',
    settings_salon_profile: 'Salon Profile',
    settings_notifications: 'Notifications',
    settings_billing: 'Billing Settings',
    settings_user_mgmt: 'User Management',
    settings_data_backup: 'Data & Backup',
    settings_salon_name: 'Salon Name',
    settings_phone: 'Phone',
    settings_email: 'Email',
    settings_address: 'Address',
    settings_gst: 'GST Number',
    settings_website: 'Website',
    settings_save: 'Save Changes',
    settings_saved: 'Settings saved!',
    settings_inv_prefix: 'Invoice Prefix',
    settings_next_inv: 'Next Invoice Number',
    settings_loyalty_per_rupee: 'Loyalty Points per ₹ spent',
    settings_redemption_per_point: 'Redemption ₹ per point',
    notif_booking_title: 'Auto-send Booking Confirmation',
    notif_booking_sub: 'Booking create hone par WhatsApp bhejo',
    notif_bill_title: 'Auto-send Bill via WhatsApp',
    notif_bill_sub: 'Payment ke baad receipt bhejo',
    notif_birthday_title: 'Birthday Wishes',
    notif_birthday_sub: 'Customer ke birthday par auto message bhejo',
    notif_reminder_title: 'Appointment Reminder',
    notif_reminder_sub: 'Appointment se pehle reminder bhejo',
    whatsapp_note: 'WhatsApp integration ke liye Business API required hai. Abhi ye manually WhatsApp Web se kaam karta hai.',
    email_config: 'Email Setup',
    resend_api_key: 'Resend API Key',
    resend_api_key_help: 'resend.com pe free API key lo',
    resend_open: 'Resend Kholo ↗',
    resend_api_key_placeholder: 're_xxxxxxxxxxxxxxxx',
    resend_api_key_invalid: 'Galat format. Key re_ se shuru honi chahiye',
    resend_used_for: 'Kaam aata hai: password reset, booking, receipt mein',
    test_email: 'Test Email Bhejo',
    test_email_sending: 'Bhej rahe hain...',
    test_email_success: 'Test email gaya! Inbox check karo.',
    test_email_failed: 'Failed. API key check karo.',
    resend_key_saved: 'Email settings save hui',
    using_system_email: 'System default email use ho raha hai',
    settings_field_required: 'zaroori hai',
    settings_user_req: 'Name aur email zaroori hai',
    settings_user_updated: 'User update ho gaya',
    settings_user_added: 'User add ho gaya',
    settings_backup_complete: 'Backup complete! 4 files download ho gayi.',
    settings_backup_failed: 'Backup fail',
    settings_try_again: 'Please try again',
    settings_restore_success: 'Data restore ho gaya!',
    settings_restore_unknown: 'Unknown file type. Customers, bookings, services ya staff CSV use karo.',
    settings_users_demo: 'Ye feature abhi demo mode mein hai. Real login system coming soon.',
    settings_table_user: 'User',
    settings_table_role: 'Role',
    settings_table_status: 'Status',
    settings_table_actions: 'Actions',
    settings_add_user: 'Add User',
    settings_backup_full: 'Full Backup to CSV',
    settings_restore_btn: 'Restore from Backup',
    settings_last_backup: 'Last backup',
    settings_never: 'Kabhi nahi',
    settings_edit_user: 'Edit User',
    settings_password_keep: '(keep ke liye blank chhodo)',
    settings_update: 'Update',
    settings_add_karo: 'Add Karo',
    settings_restore_title: 'Restore from Backup',
    settings_restore_confirm: 'Restore karne se saara current data replace ho jayega. Kya aap sure hain?',
    settings_restore_yes: 'Haan, Restore Karo',
    settings_password: 'Password',
    settings_status_active: 'Active',
    settings_status_inactive: 'Inactive',
    settings_you_badge: 'Aap',
    settings_password_optional_hint: 'Password nahi badalna? Khaali chhodein',
    settings_confirm_password: 'Confirm Password',
    settings_deactivate_confirm: 'Is user ko deactivate karein?',
    settings_deactivate: 'Deactivate',
    settings_users_load_error: 'Users load nahi hue',
    inv_total_products: 'Total Products',
    inv_low_stock: 'Low Stock',
    inv_inventory_value: 'Inventory Value',
    inv_product_add: 'Product Add Karo',
    inv_product_search: 'Product dhundho...',
    inv_filter_all: 'All',
    inv_filter_low_stock: 'Low Stock',
    inv_filter_out_of_stock: 'Out of Stock',
    inv_min_threshold: 'Min Threshold',
    inv_cost_price: 'Cost Price',
    inv_brand: 'Brand',
    inv_stock_history: 'Stock History',
    inv_stock_add: 'Stock Add Karo',
    inv_stock_reduce: 'Stock Ghataao',
    inv_update_karo: 'Update Karo',
    inv_reason_new_stock: 'New Stock',
    inv_reason_return: 'Return',
    inv_reason_correction: 'Correction',
    inv_reason_used: 'Used in Service',
    inv_reason_damaged: 'Damaged',
    inv_reason_expired: 'Expired',
    inv_products_low_stock: 'products low stock mein hain',
    inv_whatsapp_alert: 'WhatsApp Alert Bhejo',
    inv_low_stock_alert: 'Low Stock Alert',
    inv_restock_karo: 'Restock karo',
    inv_stock_updated: 'Stock update ho gaya!',
    inv_dismiss: 'Dismiss',
    inv_clear_history: 'Clear History',
    inv_low_stock_in: 'low stock mein hai',
    inv_save_karo: 'Save Karo',
    inv_min_alert_helper: 'Isse kam hone par alert milega',
    inv_current_stock: 'Current Stock',
    inv_product_name: 'Product Name',
    inv_category: 'Category',
    inv_unit: 'Unit',
    inv_type: 'Type',
    inv_quantity: 'Qty',
    inv_reason: 'Reason',
    inv_time: 'Time',
    inv_clear_confirm: 'History clear karein?',
    inv_del_title: 'Product Hata Do?',
    inv_del_desc: 'Ye wapas nahi aa sakta.',
    inv_none: 'Koi product nahi mila',
    inv_add_stock: '+ Stock Badhao',
    inv_stock_btn: 'Stock',
    inv_product: 'Product',
    use_tracking: 'Use-based tracking',
    use_per_unit: 'Uses per {unit}',
    use_name: 'Use name',
    use_stroke: 'stroke',
    use_pump: 'pump',
    use_spray: 'spray',
    use_scoop: 'scoop',
    use_available: 'strokes available',
    use_alert_below: 'Alert below (uses)',
    use_bottles_added: 'bottles added = {x} strokes added',
    use_one_call: 'Ek use ko kya bolenge?',
    use_stock_label: 'Use-based stock',
    use_per_use: 'per use',
    use_modal_helper: 'Bottle ke andar kitne use hote hain?',
    use_alert_helper: 'Kitne uses bache toh alert aaye?',
    use_status: '{x} {useUnit}s available across {y} {unit}s',
    use_kitni_units: 'Kitni {units} aayi?',
    use_kitne_use: 'Kitne {useUnit} use kiye?',
    use_added_msg: '{units} added = {x} {useUnit} added',
    val_name_min: 'At least 2 characters required',
    val_name_max: 'Maximum 100 characters',
    val_stock_min: 'Must be 0 or more',
    val_stock_number: 'Must be a number',
    val_uses_required: 'Required when use-based tracking is on',
    val_uses_min: 'At least 1 required',
    val_phone_10: 'Exactly 10 digits required',
    val_phone_numbers: 'Numbers only',
    val_email_invalid: 'Enter a valid email or leave empty',
    val_customer_or_walkin: 'Select a customer or continue as walk-in',
    val_services_one: 'Select at least one service',
    val_date_past: 'Date/time is in the past',
    val_payment_method: 'Select payment method',
    del_confirm_title: 'Delete karna chahte hain?',
    del_confirm_desc: 'Ye action undo nahi ho sakta.',
    del_confirm_btn: 'Haan, Delete Karo',
    del_cancel: 'Cancel',
    notifications: 'Notifications',
    mark_all_read: 'Sab padha mark karo',
    no_notifications: 'Koi notification nahi',
    low_stock_notif: 'Low Stock',
    new_booking_notif: 'Naya Booking',
    payment_notif: 'Payment',
    system_notif: 'System',
    my_profile: 'Meri Profile',
    change_password: 'Password Badlo',
    current_password: 'Purana Password',
    new_password: 'Naya Password',
    confirm_new_password: 'Password confirm karo',
    password_changed: 'Password badal gaya!',
    logout_confirm: 'Logout karna chahte hain?',
    logout_confirm_title: 'Logout karein?',
    just_now: 'Abhi',
    min_ago: 'min pehle',
    hour_ago: 'ghante pehle',
    hours_ago: 'ghante pehle',
    view_inventory: 'View Inventory',
    view_bookings: 'View Bookings',
    older_notifications: 'Purani notifications',
    notif_select: 'Select karo',
    notif_selected: 'selected',
    notif_delete_selected: 'Selected delete karo',
    notif_delete_all: 'Sab delete karo',
    notif_delete_all_confirm_title: 'Saari notifications delete karein?',
    notif_delete_all_confirm_body: 'Ye undo nahi hoga.',
    notif_delete_all_confirm_btn: 'Haan, Delete Karo',
    notif_deleted: 'Notification delete ho gayi',
    notif_deleted_count: '{count} notifications delete ho gayi',
    notif_delete_single_confirm: 'Ye notification delete karein?',
    payment_received: 'Payment mili',
    new_customer_added: 'Naya customer add hua',
    new_staff_added: 'Naya staff add hua',
    staff_clock_in_notif: 'Staff ne kaam shuru kiya',
    staff_clock_out_notif: 'Staff ne kaam khatam kiya',
    new_product_added: 'Naya product add hua',
    stock_updated: 'Stock update hua',
    new_service_added: 'Nayi service add hui',
    settings_updated_notif: 'Settings update ho gayi',
    select_cancel: 'Cancel',
    hours_worked: 'ghante kaam kiya',
    notif_low_stock_title: 'Low Stock Alert',
    notif_low_stock_message: '{product} ka stock kam ho raha hai',
    notif_payment_title: 'Payment Mili',
    notif_payment_message: '{customer} - ₹{amount} {method} se mila',
    notif_walkin_payment_message: 'Walk-in - ₹{amount} {method} se mila',
    notif_new_customer_title: 'Naya Customer Add Hua',
    notif_new_customer_message: '{name} ka account ban gaya',
    notif_new_staff_title: 'Naya Staff Add Hua',
    notif_new_staff_message: '{name} ({role}) ko add kiya',
    notif_clock_in_title: 'Staff Aaya',
    notif_clock_in_message: '{name} ne aaj kaam shuru kiya',
    notif_clock_out_title: 'Staff Gaya',
    notif_clock_out_message: '{name} ne {hours} ghante kaam kiya aaj',
    notif_new_product_title: 'Naya Product Add Hua',
    notif_new_product_message: '{name} inventory mein add hua',
    notif_stock_updated_title: 'Stock Update Hua',
    notif_stock_updated_message: '{name} mein {quantity} {unit} add kiye',
    notif_new_service_title: 'Nayi Service Add Hui',
    notif_new_service_message: '{name} - ₹{price} add ki',
    notif_new_booking_title: 'Naya Booking',
    notif_new_booking_message: '{customer} ki booking {time} pe',
    notif_settings_title: 'Settings Update Hui',
    notif_settings_message: 'Salon profile update ho gayi',
    notif_welcome_title: 'SalonSync mein Aapka Swagat!',
    notif_welcome_message: 'Setup complete hai. Services, staff add karo aur billing shuru karo!',
    loading: 'Load ho raha hai...',
    delete_failed: 'Delete fail',
    password_mismatch: 'Password match nahi ho raha',
    password_required: 'Current password required',
    password_update_failed: 'Password update failed',
    dash_load_error: 'Dashboard data load nahi hua',
    book_load_error: 'Bookings load nahi hui',
    book_create_error: 'Booking create nahi hui',
    book_status_error: 'Status update nahi hua',
    update_failed: 'Update nahi hua',
    book_delete_error: 'Delete nahi hua',
    book_whatsapp_confirm: 'WhatsApp pe confirmation bhejna chahte hain?',
    book_status_updated: 'Booking {status}',
    book_whatsapp_coming_soon: 'WhatsApp reminder: Coming soon!',
    settings_load_error: 'Settings load nahi hui',
    settings_save_error: 'Save nahi hua',
    cust_load_error: 'Customers load nahi hue',
    cust_save_error: 'Customer save nahi hua',
    cust_edit_load_error: 'Customer edit ke liye load nahi hua',
    cust_deactivate_error: 'Deactivate nahi hua',
    cust_reactivate_error: 'Reactivate nahi hua',
    bill_payment_failed: 'Payment fail. Dobara try karo.',
    bill_receipt_downloaded: 'Receipt PDF download ho gayi',
    bill_whatsapp_coming_soon: 'WhatsApp integration coming soon!',
    svc_load_error: 'Services load nahi hui',
    svc_save_error: 'Service save nahi hui',
    svc_delete_error: 'Service delete nahi hui',
    staff_load_error: 'Staff load nahi hue',
    staff_save_error: 'Staff save nahi hua',
    staff_clock_in_error: 'Clock in nahi hua',
    staff_clock_out_error: 'Clock out nahi hua',
    staff_delete_error: 'Staff delete nahi hua',
    app_access: 'App Access',
    give_app_access: 'SalonSync app access do',
    app_access_enabled: 'App access active hai',
    app_access_disabled: 'App access nahi hai',
    app_access_card_active: 'Active',
    app_access_card_off: 'Not enabled',
    app_access_no_access: 'No access',
    app_access_active_line: 'Active — {email}',
    app_access_optional_section: 'App Access (Optional)',
    app_access_cannot_login: 'Staff member SalonSync mein login nahi kar payega.',
    app_access_login_blurb: 'Ye credentials se login karenge. Role: {role} — {access}',
    enable_login: 'Login enable karo',
    disable_login: 'Access hatao',
    change_password: 'Password badlo',
    login_email: 'Login Email',
    login_password: 'Login Password',
    login_password_placeholder: 'Min 8 characters',
    staff_app_access_title: 'Staff App Access',
    staff_app_access_subtitle: 'Kaun login kar sakta hai aur kya dekh sakta hai, manage karo',
    add_staff_member: 'Staff Add Karo',
    staff_table_member: 'Staff Member',
    staff_has_app_access_email: 'App access hai ({email})',
    remove_app_access_confirm: 'Ab sign in nahi kar payenge. Baad mein access wapas on kar sakte ho.',
    role_access_owner: 'Full access',
    role_access_manager: 'Settings ke alawa sab',
    role_access_receptionist: 'Bookings, Billing, Customers',
    role_access_stylist: 'Sirf Bookings',
    auth_failed: 'Authentication fail',
    demo_loaded: 'Demo data load! owner@salonsync.com / admin123 se login karo',
    demo_load_error: 'Demo data load nahi hua',
    login_welcome_toast: 'Welcome, {name}!',
    login_welcome_back_toast: 'Welcome back, {name}!',
  }
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => localStorage.getItem('salon_language') || 'en');

  useEffect(() => {
    localStorage.setItem('salon_language', language);
  }, [language]);

  const t = (key, params) => {
    let str = translations[language]?.[key] || translations.en[key] || key;
    if (params && typeof params === 'object') {
      Object.keys(params).forEach(k => { str = str.replace(new RegExp(`\\{${k}\\}`, 'g'), String(params[k])); });
    }
    return str;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}

/** Use outside React (e.g. in api interceptor) to get translated string by key. Supports params: getTranslation(key, { product: 'X' }). */
export function getTranslation(key, params) {
  const lang = typeof localStorage !== 'undefined' ? localStorage.getItem('salon_language') || 'en' : 'en';
  let str = translations[lang]?.[key] || translations.en[key] || key;
  if (params && typeof params === 'object') {
    Object.keys(params).forEach(k => { str = str.replace(new RegExp(`\\{${k}\\}`, 'g'), String(params[k])); });
  }
  return str;
}
